import { css, keyframes } from '@emotion/core'
import styled, { ThemeProps, Theme } from '@themes/theme'
import {
  ShowAni,
  LetterSpace,
  TxtLimit2,
  mq,
  mqMin,
  ShowHidden, TxtLimit, NavBottomPadding,
} from '@styles/base.style'
import { ButtonStyles } from '@styles/button.style'
import { dividendBoardStyle } from '@views/Matchup/MatchUpDetail/index.style'

export const OddsChangeAnimationStopTime = 10000

export const Hit = (theme: Theme) =>
  css`
    background: ${theme.color.select} !important;
    span:not(.match-result .result) {
      color: ${theme.color.themeTxt} !important;
    }
  `
export const Miss = (theme: Theme) =>
  css`
    /* background: red !important; */
      /* span:not(.match-result) {
      color: ${theme.color.contentsBg};
    } */
  `
export const Win = (theme: Theme) =>
  css`
    color: ${theme.color.themeTxt};
    &.score-num {
      color: ${theme.color.red};
    }
  `
export const Lose = (theme: Theme) =>
  css`
    color: ${theme.color.gray};
    &.score-num {
      color: ${theme.color.themeTxt};
    }
  `
// 경기결과에서만 사용되는 색상
export const ResultWin = (theme: Theme) =>
  css`
    color: ${theme.color.modalTxt};
    &.score-num {
      color: ${theme.color.red};
    }
  `
export const ResultLose = (theme: Theme) =>
  css`
    color: ${theme.color.modalTxt};
    &.score-num {
      color: ${theme.color.modalTxt};
    }
  `
// 경기결과 팀명 말줄임제거
export const ResultTxtStyle = css`
  white-space: normal;
`
export const straightBet = (theme: Theme) =>
  css`
    color: ${theme.color.modalTxt};
    &.reverse {
      color: ${theme.color.modalred};
    }
    &.result-page {
      color: ${theme.color.themeTxt};
      font-weight: ${theme.fontW.bold};
    }
  `
export const normalBet = (theme: Theme) =>
  css`
    color: ${theme.color.disableTxt};
  `
export const favoritePlusAni = keyframes`
  0% {
    opacity: 1;
    top: 8px;
    transform: scale(1.3);
  }
  25% {
    opacity: 1;
    //transform: scale(1.15);
  }
  90% {
    //opacity: 0;
  }
  100% {
    //opacity: 0;
    top: 0;
    transform: scale(1.1) translateX(-0.5%);
    //transform: scale(.7);
  }
`
// 찜 관련 애니
export const favoriteTxtAni = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(1);
  }
  22% {
    transform: translate(-50%, -50%) scale(1.24);
  }
  47% {
    transform: translate(-50%, -50%) scale(.88);
  }
  80% {
    transform: translate(-50%, -50%) scale(1.05);
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
  }
`
export const favoritePulseAni = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 197, 21, .4);
  }
  70% {
    transform: translate(-50%, -50%) scale(1);
    box-shadow: 0 0 0 9px rgba(255, 197, 21, 0);
  }
  100% {
    transform: translate(-50%, -50%) scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 197, 21, 0);
  }
`

// 매치업 공통 높이 설정
export const MatchBtnH = '3.6rem'
export const PCMatchBtnH = '3.8rem'
// 경기별 header
export const HeaderStyle = (props: ThemeProps) => css`
  overflow: hidden;
  &::before {
    content: '';
    z-index: -1;
    display: block;
    position: absolute;
    width: 90px;
    height: 22px;
    top: 0;
    left: 0;
    background: ${props.theme.color.matchTit1};
  }
  &::after {
    content: '';
    z-index: -1;
    display: block;
    position: absolute;
    width: 16px;
    height: 22px;
    top: 2px;
    left: 88px;
    border-top: 11px solid transparent;
    border-bottom: 11px solid ${props.theme.color.matchTit1};
    border-right: 11px solid transparent;
    border-left: 11px solid ${props.theme.color.matchTit1};
    transform: rotate(10deg);
  }
`
export const SportsIco = styled.span`
  position: relative;
  display: inline-block;
  width: auto;
  min-width: 13px;
  height: 13px;
  min-height: 13px;
  //margin-right: 4px;
  vertical-align: middle;
  transform: translateY(-1px);
  svg {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate3d(0, -50%, 0);
    width: auto;
    height: inherit;
    color: ${props => props.theme.color.themeTxt};
    &.soccer {
      top: 1px;
      width: 17px;
    }
  }
  img {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(0, -50%);
    width: auto;
    height: inherit;
  }
  &.etc-sports-ico {
    margin-right: 6px;
  }
`
// /////////////////////////////////////////// match up button /////////////////////////////////////////////
// eslint-disable-next-line @typescript-eslint/no-unused-vars
// const MatchCommonH = '38px'
export const MatchWrapper = styled.div`
  .live-match-bg {
    display: none;
  }
  .odds-block-list-content {
    border-radius: 18px;
    margin-bottom: 6px;
    background: ${props => props.theme.color.mainColor};
    border: 1px solid #303B49;
    &.hot {
      border: 1px solid transparent;
      background-image: linear-gradient(${props => props.theme.color.mainColor}, ${props => props.theme.color.mainColor}), linear-gradient(-48deg, #C9C9C966 0%, #3E444E66 32%, #464F6266 77%, #F2F7FF66 100%);
      background-origin: border-box;
      background-clip: content-box, border-box;
    }
  }
  .match-block-header {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    width: 100%;
    height: 36px;
    padding: 0 27px;
    text-align: left;
    overflow: hidden;
    .tournament-info {
      width: 100%;
      height: 36px;
      &.live {
        background: ${props => props.theme.color.mainBg};
      }
      &, & > button {
        line-height: 3.6rem;
      }
      .tournament-wrap {
        ${TxtLimit};
        width: auto;
        max-width: calc(100% - 70px);
        display: inline-block;
        vertical-align: middle;
        text-align: left;
        &.filter {
          max-width: calc(100% - 109px);
        }
        img {
          width: auto;
          height: 14px;
          margin-right: 4px;
          transform: translateY(-1px);
          &.tournament-emblem {
            height: 16px;
            margin-left: 6px;
          }
        }
      }
      .tournament-name {
        max-width: calc(100% - 154px);
        ${TxtLimit};
        & + svg {
          width: 22px;
          min-width: 22px;
          transform: rotate(-90deg) translateX(-3px);
        }
      }
      .tournament-match-count {
        margin-left: 6px;
        color: ${props => props.theme.color.gray};
      }
      .favorite-all-btn {
        width: 36px;
        height: 36px;
        margin-left: -2px;
        .favorite-btn-img {
          width: 18px;
          height: auto;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          opacity: 1;
        }
        .favorite-btn-active-img {
          width: 18px;
          height: auto;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          opacity: 0;
        }
        &.active {
          .favorite-btn-active-img {
            opacity: 1;
          }
        }
      }
      // 리그 필터 화살표 아이콘
      svg {
        width: 22px;
        margin-top: -6px;
        transform: rotate(-90deg) translateX(-7px) translateY(-2px);
        path {
          &#bg {
            fill: none;
          }
          &#arrow {
            fill: ${props => props.theme.color.btn};
          }
        }
        &.favorite-all {
          width: 18px;
          transform: translateY(4px);
        }
      }
    }
    // 연장포함/미포함 텍스트
    .extra-inning, .no-extra-inning {
      float: right;
      width: auto;
      height: 36px;
      line-height: 36px;
      padding-top: 1px;
      text-align: center;
      color: ${props => props.theme.color.btn};
      font-size: ${props => props.theme.font.small};
    }
  }
  .match-block-body {
    margin: 0 14px;
    .odds-block-list {
      /* 경기 header */
      &--header {
        z-index: 2; // [이슈링크] (https://task.zempublic.co.kr/view.php?id=9678)
        position: relative;
        width: 100%;
        height: 40px;
        line-height: 4rem;
        padding: 0 0 0 14px;
        text-align: left;
        &::before, &::after {
          content: '';
          z-index: -1;
          display: block;
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 1px;
          border-bottom: 1px solid ${props => props.theme.color.mainBg};
        }
        &::after {
          bottom: -1px;
          border-color: ${props => props.theme.color.disableBg};
          opacity: .2;
        }
      }
      &--hot-icon {
        display: inline-block;
        width: 46px;
        height: auto;
        margin: 0 -4px 0 -6px;
        transform: translateY(-1px);
        > img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        &.result {
          transform: translateY(0);
        }
      }
      &--date {
        margin-right: 2px;
        color: ${props => props.theme.color.disableTxt};
      }
      /* visual/detail button */
      &--btn {
        position: relative;
        float: right;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 39px;
        height: 39px;
        margin-right: 1px;
        /* 상세 bet 뒷배경 */
        &--txt {
          position: relative;
          width: 45px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding-right: 8px;
          font-size: 1.1rem;
          color: #EDF7FE;
        }
        &--num {
          margin-top: -0.5px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.1rem;
          color: #EDF7FE;
        }
        &--img {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: auto;
          height: 30px;
          z-index: -1;
          &.arrow {
            top: calc(50% - 0.5px);
            left: calc(50% + 7px);
            width: 9px;
            height: 9px;
          }
        }
        &--circle {
          width: 27px;
          height: 27px;
          line-height: 2.7rem;
          color: ${props => props.theme.color.mainBg};
          font-size: ${props => props.theme.font.small};
          background: ${props => props.theme.color.modalSubBg2};
          border-radius: 50%;
        }
        &.detail {
          margin: 1px 8px 0 5px;
          /* 비활성화 */
          &.disabled {
            .odds-block-list--btn--circle {
              background: ${props => props.theme.color.disableTxt};
              opacity: .2;
            }
          }
        }
        /* visualization 찜 버튼 */
        &.sub-btn {
          top: 1px;
          background: none;
          border-radius: 0;
          .btn-bg {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 30px;
            height: 30px;
            background: ${props => props.theme.color.TP} !important;
          }
          svg {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 26px; // visual-ico 너비 기준
            path {
              fill: ${props => props.theme.color.themeTxt};
            }
          }
          .pick-ico {
            width: 15px;
            left: calc(50% + 1px);
          }
          .sport-talk-ico {
            top: calc(50% + 1px);
            width: 14.5px;
            transform: translate(calc(-50% - 0.5px), calc(-50% - 1.5px));
          }
          .visual-ico {
            left: calc(50% - 0.5px);
          }
          // 경기결과_응원글버튼, 분석글버튼
          &.result-page {
            &:first-of-type {
              margin-right: 11px;
            }
            svg {
              .fill, path {
                fill: ${props => props.theme.color.subColor2};
              }
            }
          }
          // 찜 버튼
          .favorite-btn-img {
            width: 16px;
            height: auto;
            opacity: 1;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          .favorite-btn-active-img {
            width: 16px;
            height: 16px;
            opacity: 0;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          &.favorite-btn {
            overflow: visible;
            position: absolute;
            right: 0;
            top: -3px;
            margin-right: 8px;
            z-index: 0;
            svg {
              width: auto;
              height: 30px;
              .fill {
                fill: ${props => props.theme.color.disableBg};
              }
            }
            .favorite-pulse {
              opacity: 0;
              position: absolute;
              top: 50%;
              left: 50%;
              width: 10px;
              height: 10px;
              border-radius: 50%;
              &.pulse-2 {
                width: 6px;
                height: 6px;
              }
            }
            &.active {
              .favorite-btn-img {
                opacity: 0;
              }
              .favorite-btn-active-img {
                opacity: 1;
              }
              &.ani {
                .favorite-btn-active-img {
                  animation: ${favoriteTxtAni} .4s 1 forwards cubic-bezier(.43, -0.78, 0, 1.66);
                }
              }
              svg {
                .fill {
                  fill: transparent;
                  filter: drop-shadow(0.5px 0.5px 2px #51556050);
                }
              }
              &.ani {
                .favorite-pulse {
                  opacity: 1;
                  animation: ${favoritePulseAni} .65s 1 ease-out;
                  //animation-delay: .04s;
                  &.pulse-2 {
                    //animation-delay: .16s;
                    animation-delay: .1s;
                  }
                }
                svg {
                  animation: ${favoriteTxtAni} .4s 1 forwards cubic-bezier(.43, -0.78, 0, 1.66);
                  //animation-delay: .02s;
                }
              }
            }
          }
          /* 비활성화 */
          &.disabled {
            display: none;
          }
          &.pick-btn-wrap {
            .pick-btn {
              border-radius: 0;
              background: ${props => props.theme.color.TP};
            }
          }
        }
        &.pc {
          .odds-block-list--btn--circle {
            background: ${props => props.theme.color.themeTxt};
          }
        }
      }
      /* 라이브 팀/스코어 영역 */
      &--live-board {
        position: relative;
        display: -ms-grid;
        display: grid;
        grid-template-rows:repeat(4, 1fr);
        grid-template-columns: repeat(5, 1fr);
        grid-template-areas: 'home away score status';
        align-items: center;
        width: 100%;
        height: 83px;
        padding: 15px 10px 12px;
        .match-record-btn {
          position: absolute;
          top: 0;
          left: 50%;
          width: 100%;
          height: 100%;
          transform: translateX(-50%);
          border-radius: 0;
          z-index: 0;
          .btn-bg {
            display: none;
          }
          svg {
            display: none;
          }
        }
        .home-tag {
          position: absolute;
          top: 13px;
          left: 35px;
          width: 16px;
          height: 16px;
        }
        &.match-result {
          height: 100px;
          padding: 18px 18px 24px;
        }
        &--team {
          text-align: center;
          .emblem {
            display: block;
            width: auto;
            height: 34px;
            margin: 0 auto 7px;
          }
          .name {
            float: left;
            width: 100%;
          }
          &.home {
            grid-area: home;
            grid-column: 1/ span 2;
            grid-row: 1/ span 4;
            margin-right: 17px;
          }
          &.away {
            grid-area: away;
            grid-column: 4/ span 5;
            grid-row: 1/ span 4;
            margin-left: 17px;
          }
        }
        &--score {
          grid-area: score;
          display: flex;
          flex-wrap: nowrap;
          text-align: center;
          grid-column: 2/ span 3;
          grid-row: 1/ span 2;
          align-items: center;
          position: relative;
          gap: 6px;
          .left, .right {
            position: relative;
            flex: 4;
            text-align: right;
            font-size: 2.4rem;
          }
          .center {
            flex: 1;
            margin: 0 10px;
            font-size: 2rem;
            color: ${props => props.theme.color.gray};
            line-height: 1;
          }
          .score-num {
            line-height: 1;
            display: flex;
            align-items: center;
            gap: 6px;
            &.left {
              justify-content: flex-end;
            }
            &.right {
              justify-content: flex-start;
            }
          }
          .right {
            text-align: left;
          }
          .volleyball-score {
            position: absolute;
            top: -6px;
            left: 0;
            width: 100%;
            display: flex;
            align-items: center;
            &.home {
              justify-content: flex-end;
              .volleyball-score--img {
                margin-left: 4px;
              }
            }
            &.away {
              justify-content: flex-start;
              .volleyball-score--img {
                margin-right: 6px;
              }
            }
            &--img {
              display: inline-block;
              width: 5px;
              height: 5px;
              background: ${props => props.theme.color.themeTxt};
              border-radius: 50%;
            }
          }
          .penalty-score {
            color: ${props => props.theme.color.modalBg};
          }
          /* 매치업 결과 */
          &.result {
            grid-row: 1/ span 3;
            .left, .right {
              flex: 6;
              font-size: 1.6rem;
              overflow: visible;
              white-space: nowrap;
            }
            .center {
              font-size: 1.6rem;
            }
            .penalty-score {
              color: ${props => props.theme.color.disableBg};
            }
            .volleyball-score--img {
              background: ${props => props.theme.color.subColor};
            }
          }
        }
        // 매치업 결과 - 연장 표시
        .overtime-wrap {
          grid-row: 3/ span 3;
          grid-column: 3/ span 1;
          text-align: center;
          .overtime {
            display: inline-block;
            width: 38px;
            height: 23px;
            line-height: 23px;
            font-weight: ${props => props.theme.fontW.medium};
            color: ${props => props.theme.color.themeTxt};
            background: rgba(80, 96, 112, .3);
            border-radius: 4px;
          }
        }
        &--status {
          grid-area: status;
          grid-column: 2/ span 3;
          grid-row: 3/ span 3;
          text-align: center;
          svg {
            position: relative;
            top: 2px;
            width: auto;
            height: 12px;
          }
          .name {
            margin-left: 4px;
            color: ${props => props.theme.color.gray};
          }
        }
      }
      /* 경기 body */
      &--body {
        position: relative;
        border-radius: 0 0 15px 15px;
        padding-bottom: 3px;
      }
      /* 경기 정보(팀 vs 팀) */
      &--team-info {
        position: relative;
        width: calc(100% - 39px);
        height: 36px;
        line-height: 3.6rem;
        display: flex;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-items: center;
        padding: 0 14px;
        &--home {
          width: auto;
          height: 12px;
          margin-right: 4px;
        }
        &--name {
          max-width: 100%;
          display: inline-block;
          font-weight: 500;
        }
        &--emblem {
          width: auto;
          height: 18px;
          margin-top: -1px;
          margin-right: 4px;
        }
        &--vs {
          margin: 0 6px;
          color: ${props => props.theme.color.btn};
        }
      }
      /* 타입별(승무패/핸디캡/언더오버) */
      &--team-btn {
        position: relative;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: flex-start;
        padding: 0 14px;
        // 승무패/핸디캡/언더오버
        .match-type {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 50px;
          height: ${MatchBtnH};
          color: ${props => props.theme.color.gray};
          font-size: ${props => props.theme.font.small};
          text-align: center;
          .small {
            color: ${props => props.theme.color.gray};
            font-size: ${props => props.theme.font.tiny};
            letter-spacing: -1px;
          }
        }
        .odds-block-radio-group {
          display: flex;
          flex: 1;
          justify-content: space-between;
          align-items: flex-start;
          max-width: 100%;
          .odds-block-radio-btn {
            width: calc((100% - 16px) / 3);
            height: ${MatchBtnH};
            line-height: ${MatchBtnH};
            margin-bottom: 6px;
            padding: 0 12px;
            background: ${props => props.theme.color.mainBg};
            border-radius: 30px;
            border: none;
            /* 버튼 클릭 애니메이션 제거 */
            transition: none;
            /* 기본 라인 제거 */
            &::before {
              display: none;
            }
            &.center {
              .rate-change {
                right: 28%;
              }
            }
            /* 버튼 활성화시 */
            &.ant-radio-button-wrapper-checked {
              background: ${props => props.theme.color.underover};
              box-shadow: none;
              .odds-block-radio-btn--team--type, .odds-block-radio-btn--team--num .rate {
                color: ${props => props.theme.color.subBg};
              }
            }
            /* 버튼 비활성화시 */
            &.ant-radio-button-wrapper-disabled {
              z-index: 1;
              background: none;
              &::before {
                content: '';
                z-index: -1;
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: inherit;
                border-radius: 50px;
                background: ${props => props.theme.color.disableTxt};
                opacity: .3;
              }
              .odds-block-radio-btn--team--type {
                color: ${props => props.theme.color.disableTxt};
              }
              .odds-block-radio-btn--team--num {
                opacity: .5;
              }
            }
            /* 배당판 버튼 하위 내용 */
            &--team {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
              &--type {
                text-align: center;
                color: ${props => props.theme.color.disableTxt};
                font-size: ${props => props.theme.font.small};
                &.center {
                  color: ${props => props.theme.color.modalSubBg};
                }
              }
              &--num {
                text-align: right;
                height: ${MatchBtnH};
                .rate {
                  display: inline-block;
                  max-width: 38px;
                  ${TxtLimit};
                  color: ${props => props.theme.color.yellow};
                }
                /* 언더오버 화살표 아이콘 */
                .underover-ico {
                  width: 8px;
                  line-height: 3.3rem;
                  &.up {
                    margin-left: 4px;
                    svg path {
                      fill: ${props => props.theme.color.red};
                    }
                  }
                  &.down {
                    margin-right: 4px;
                    svg {
                      width: inherit;
                      transform: rotate(180deg);
                      path {
                        fill: ${props => props.theme.color.blue};
                      }
                    }
                  }
                }
              }
              /* 중앙 버튼 */
              &.center {
                .odds-block-radio-btn--team--type, svg, .blank {
                  flex: 1;
                }
                .odds-block-radio-btn--team--num {
                  flex: 2;
                }
              }
            }
            /* &-team */

            /* 핸디캡/언더오버 modal 버튼 */
            &.modal-btn {
              background: none;
              .odds-block-radio-btn--team {
                &--num {
                  .rate {
                    color: ${props => props.theme.color.underover};
                  }
                }
              }
              /* 화살표 icon 스타일 */
              svg {
                float: right;
                position: relative;
                width: 16px;
                height: 16px;
                left: 8%;
                #bg {
                  opacity: .5;
                }
              }
              /* 기준점 버튼 비활성화 */
              &.disabled {
                svg {
                  display: none;
                }
              }
            }
          }
          // 기준점 collapse
          .match-btn-collapse {
            width: calc((100% - 16px) / 3);
            padding: 0 12px;
            font-size: 1.2rem;
            .am-accordion-item {
              .am-accordion-content {
                display: block;
              }
              &:not(.am-accordion-item-active) .am-accordion-content {
                display: none;
              }
            }
            .am-accordion-item-active .odds-block-radio-btn--team {
              & > svg {
                transform: rotate(180deg);
              }
            }
            .odds-block-list--team-btn {
              padding: 0;
            }
            .ant-collapse-header, .am-accordion-header {
              height: ${MatchBtnH};
              margin-bottom: 6px;
              padding: 0;
              text-align: center;
              border: none;
              background: transparent;
              overflow: visible;
              i {
                display: none;
              }
              .odds-block-radio-btn--team.center {
                height: 3.6rem;
                line-height: 3.6rem;
                padding: 0 1px;
                svg {
                  height: 16px;
                  width: 16px;
                  min-width: 16px;
                  left: 8%;
                  position: relative;
                  #bg {
                    opacity: .5;
                  }
                }
              }
              .odds-block-radio-btn--team--num .rate {
                color: ${props => props.theme.color.underover};
              }
            }
            .ant-collapse-content, .am-accordion-content {
              position: relative;
              left: 50%;
              transform: translateX(-50%);
              width: 500%;
              max-width: calc(100vw - 28px);
              transition: none !important;
              background: none;
              .ant-collapse-content-box, .am-accordion-content-box {
                width: 100%;
                padding: 6px 1px 0;
                background: rgba(80, 96, 112, .1);
                .odds-block-modal {
                  width: 100%;
                  margin: 0 auto 6px;
                  overflow-y: hidden;
                  .odds-block-radio-group {
                    padding: 0 14px;
                    .odds-block-radio-btn {
                      width: calc((100% - 16px) / 3);
                      &.ant-radio-button-wrapper-disabled::before {
                        background: #383E49;
                        opacity: 1;
                      }
                    }
                  }
                }
              }
            }
            &.no-match {
              .am-accordion-header {
                cursor: default;
              }
              .am-accordion-content {
                display: none;
              }
            }
          }
          /* two way(승무패 / 라이브) */
          &.two-way {
            .odds-block-radio-btn {
              width: 38%;
            }
          }
        }
      }
      &--footer {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 32px;
        line-height: 3.2rem;
        border-top: 1px solid ${props => props.theme.color.subBg};
        background: ${props => props.theme.color.contentsBg};
        .special-tag-tit {
          text-indent: 14px;
          position: relative;
          color: ${props => props.theme.color.gray};
          svg {
            position: absolute;
            top: 50%;
            left: 0;
            width: 12px;
            transform: translate(0, -52%);
            path {
              fill: ${props => props.theme.color.yellow};
              &.dark {
                fill: ${props => props.theme.color.mainBg};
              }
            }
          }
        }
        .special-hashtag {
          margin-left: 10px;
          text-decoration: underline;
          color: ${props => props.theme.color.themeTxt};
          cursor: pointer;
        }
      }
    }

    /* ****** 라이브 매치 ****** */
    &.live {
      .odds-block-list-content {
        z-index: 1;
        position: relative;
        overflow: hidden;
        .live-match-bg {
          display: block;
          z-index: -1;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 100%;
          height: 100%;
          min-height: 170px;
          object-fit: cover;
          opacity: .2;
          &::after {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: inherit;
            background: ${props => props.theme.color.mainBg};
            opacity: 1;
          }
        }
        &.before {
          .live-match-bg {
            display: none;
          }
        }
      }
      .odds-block-list {
        &--header::before {
          opacity: .8;
        }
        &--body {
          background: none;
        }
        /* live visual/detail button */
        &--btn {
            /* color: ${props => props.theme.color.themeTxt};
          background: ${props => props.theme.color.red}; */
        }
        &--team-btn {
          .odds-block-radio-group {
            /* disalbed 제외하고 라인추가 */
            .odds-block-radio-btn:not(.ant-radio-button-wrapper-disabled) {
              position: relative;
              &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                display: block;
                width: 100%;
                height: ${MatchBtnH};
                border-radius: 50px;
                border: 1px solid #2F455D;
              }
            }
          }
        }
      }
    }
    /* *** 배당률 변화 *** */
    .ant-radio-button-wrapper:not(:first-of-type)::before {
      background: none;
    }
    .ant-radio-button-wrapper-checked .up-num,
    .ant-radio-button-wrapper-checked .down-num {
      text-shadow: -1px -1px 0 rgba(0, 0, 0, .2),
      1px -1px 0 rgba(0, 0, 0, .2),
      -1px 1px 0 rgba(0, 0, 0, .2),
      1px 1px 0 rgba(0, 0, 0, .2);
    }
    .ant-radio-group .ant-radio-button-wrapper.up {
      z-index: 1;
      &:not(.ant-radio-button-wrapper-disabled)::before {
        z-index: -1;
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: ${MatchBtnH};
        border: 1px solid ${props => props.theme.color.red} !important;
        border-radius: 50px;
        animation: ${ShowAni} 1s alternate forwards;
        animation-iteration-count: infinite;
      }
      &.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
        background-color: ${props => props.theme.color.redBg} !important;
      }
    }
    .ant-radio-group .ant-radio-button-wrapper.down {
      z-index: 1;
      &:not(.ant-radio-button-wrapper-disabled)::before {
        z-index: -1;
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: ${MatchBtnH};
        border: 1px solid ${props => props.theme.color.blue} !important;
        border-radius: 50px;
        background: none;
        animation: ${ShowAni} 1s alternate forwards;
        animation-iteration-count: infinite;
      }
      &.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
        background-color: #236189 !important;
      }
    }
    /* 라이브 비활성화일때 */
    .ant-radio-button-wrapper-disabled {
      color: ${props => props.theme.color.disableTxt};
      background-color: ${props => props.theme.color.disableBg};
      .rate-change {
        display: none;
      }
    }
  }
  /* match-block-body */
  // 상세 BET
  &.match-detail {
    margin: 0 14px 165px;
    padding-bottom: ${NavBottomPadding};
    &.accordion-wrap {
      z-index: 0; /* MarketTooltip이 탭을 가리는 문제로 인해 추가 */
      position: relative;
    }
    .ant-collapse {
      background: none !important;
      .ant-collapse-item {
        border-radius: 18px !important;
        margin-bottom: 6px;
        background: ${props => props.theme.color.mainColor};
        border: 1px solid #303B49 !important;
        overflow: hidden;
        &.main-market {
          border: 1px solid ${props => props.theme.color.disableBg} !important;
          .ant-collapse-header {
            background: ${props => props.theme.color.subColor};
          }
          .ant-collapse-content {
            .ant-collapse-content-box {
              background: ${props => props.theme.color.subColor};
              .market-type {
                &::before {
                  border-color: ${props => props.theme.color.mainColor};
                }
              }
            }
          }
        }
        .ant-collapse-header {
          height: 40px;
          line-height: 4rem;
          padding: 0 8px 0 14px;
          text-align: left;
          background: ${props => props.theme.color.mainColor};
          .market-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            line-height: 3.9rem;
          }
          .market-info {
            display: flex;
            width: calc(100% - 40px);
            height: 39px;
            align-items: center;
            &--btn {
              z-index: 0;
              width: 42px;
              min-width: 42px;
              height: 100%;
              margin-left: -14px;
              margin-right: -7px;
              text-align: center;
              background: none;
              svg {
                width: 14px;
                height: auto;
                margin-top: 1px;
                transition: all .3s;
                .fill {
                  fill: ${props => props.theme.color.mainColor};
                }
                .bg {
                  fill: ${props => props.theme.color.themeTxt};
                }
              }
              &.show {
                svg {
                  .bg {
                    fill: ${props => props.theme.color.underover};
                  }
                }
              }
            }
            &--name {
              ${TxtLimit};
            }
            &--team-name {
              color: ${props => props.theme.color.primary};
            }
          }
          .main-market-icon {
            width: 12px;
            height: 12px;
            margin: 0 3px 1px 0;
          }
          .detail-bet-favorites-btn {
            float: right;
            z-index: 0;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            width: 40px;
            height: 40px;
            background: none;
            .btn-bg {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 27px;
              height: 27px;
              border-radius: 50%;
                //background: ${props => props.theme.color.mainBg};
              overflow: hidden;
            }
            svg {
              position: relative;
              width: 27px;
              height: auto;
              path {
                &.fill {
                  fill: ${props => props.theme.color.disableBg};
                }
              }
              .fill {
                fill: ${props => props.theme.color.disableBg};
              }
            }
            // 찜버튼 - 상세 bet
            .favorite-btn-img {
              width: 16px;
              height: auto;
              opacity: 1;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
            .favorite-btn-active-img {
              width: 16px;
              height: auto;
              opacity: 0;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
            // 즐겨찾기 활성화
            &.active {
              .favorite-btn-img {
                opacity: 0;
              }
              .favorite-btn-active-img {
                opacity: 1;
              }
            }
          }
          .arrow {
            display: none;
          }
        }
        .ant-collapse-content {
          background: transparent;
          .ant-collapse-content-box {
            padding: 0;
            background: ${props => props.theme.color.mainColor};
            .market-type {
              position: relative;
              //padding: 9px 14px;
              padding: 12px 14px 9px;
              &::before, &::after {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                left: 50%;
                transform: translateX(-50%);
                width: calc(100% - 28px);
                height: 1px;
                border-bottom: 1px solid ${props => props.theme.color.mainBg};
              }
              &::after {
                top: 1px;
                border-color: ${props => props.theme.color.disableBg};
                opacity: 0.2;
              }
              .outcome-name {
                display: flex;
                align-items: center;
                gap: 6px;
                &--txt {
                  flex: 1;
                  ${TxtLimit};
                  line-height: 18px;
                  padding: 0 0 6px;
                  font-weight: ${props => props.theme.fontW.medium};
                  color: #798897;
                  &.button-2ways {
                    max-width: calc((100% - 8px) / 2);
                  }
                  &.button-3ways {
                    max-width: calc((100% - 16px) / 3);
                  }
                }
                &.point {
                  padding-left: 64px; /* market-point 만큼 여백 */
                }
              }
              .outcome-btn-wrap {
                .ant-radio-group {
                  display: flex;
                  align-items: center;
                  flex-wrap: wrap;
                  gap: 6px;
                  width: 100%;
                  &.button-2ways {
                    .ant-radio-button-wrapper {
                      width: calc((100% - 8px) / 2);
                    }
                    .match-point ~ .ant-radio-button-wrapper {
                      width: calc((100% - 68px) / 2);
                    }
                  }
                  &.button-3ways {
                    .ant-radio-button-wrapper {
                      width: calc((100% - 16px) / 3);
                    }
                  }
                  .btn-group {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    width: 100%;
                  }
                  .match-point {
                    min-width: 56px;
                    text-align: center;
                    color: #798897;
                    font-weight: ${props => props.theme.fontW.medium};
                  }
                  .ant-radio-button-wrapper {
                    height: ${MatchBtnH};
                    line-height: ${MatchBtnH};
                    padding: 0 12px;
                    background: ${props => props.theme.color.mainBg};
                    border-radius: 30px;
                    border: none;
                    /* 버튼 클릭 애니메이션 제거 */
                    transition: none;
                    &::before {
                      display: none;
                    }
                    // 택스트 + 배당 case
                    .radio-button-outcome-name {
                      float: left;
                      color: ${props => props.theme.color.disableTxt};
                      font-weight: ${props => props.theme.fontW.medium};
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      word-wrap: normal;
                      width: 49%;
                      text-align: left;
                      overflow: hidden;
                    }
                    .radio-button-rate {
                      color: ${props => props.theme.color.yellow};
                      &.float {
                        float: right;
                      }
                    }
                    .radio-button-lock {
                      display: none;
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      width: 10px;
                      height: 13px;
                    }
                  }
                  // 클릭 시
                  .ant-radio-button-wrapper-checked {
                    z-index: 0;
                    border: none;
                    background: ${props => props.theme.color.underover};
                    box-shadow: none;
                    outline: none;
                    &::before {
                      display: none;
                    }
                    .radio-button-rate, .radio-button-outcome-name {
                      color: ${props => props.theme.color.subBg};
                    }
                  }
                  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
                    box-shadow: none;
                  }
                  .ant-radio-button-wrapper:not(:first-of-type)::before {
                    background: none;
                  }
                  //비활성화
                  .ant-radio-button-wrapper-disabled {
                    &::after {
                      content: '';
                      display: block;
                      position: absolute;
                      top: 0;
                      left: 0;
                      width: 100%;
                      height: inherit;
                      background: ${props => props.theme.color.disableTxt};
                      opacity: .3;
                      border-radius: 30px;
                    }
                    .radio-button-outcome-name, .radio-button-rate {
                      display: none;
                    }
                    .radio-button-lock {
                      display: block;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  // 경기결과
  &.matchup-result {
    .match-block-body {
      .odds-block-list-content {
        border: none;
        background: linear-gradient(150deg, #DFE2EC, #BEC3CC);
        box-shadow: inset 1px 1px 0.5px #ffffff30, 1px 1px 6px #00000016;
        margin-bottom: 8px;
        .odds-block-list {
          &--header {
            .btn-bg {
              background: #BEC4CF;
            }
            svg {
              path {
                &.fill {
                  fill: ${props => props.theme.color.subColor2};
                }
              }
            }
            .odds-block-list {
              &--date {
                font-weight: ${props => props.theme.fontW.medium};
                color: ${props => props.theme.color.disableTxt};
              }
              &--time {
                font-weight: ${props => props.theme.fontW.medium};
                color: ${props => props.theme.color.modalTxt};
              }
            }
            ::before {
              border-color: #A4ABB7;
              box-shadow: 0 1px 1px ${props => props.theme.color.themeTxt};
            }
            ::after {
              border: none;
            }
          }
          &--body {
            padding-bottom: 10px;
            .match-result {
              padding: 25px 0 0 0;
              margin-bottom: 0 !important;
              height: 108px;
              > span {
                height: 100%;
              }
            }
            .favorite-btn {
              svg {
                .fill {
                  fill: #A4ABB7;
                }
              }
              &.active {
                .favorite-btn-active-img {
                  opacity: 1;
                }
                &.ani {
                  .favorite-btn-active-img {
                    animation: ${favoriteTxtAni} .4s 1 forwards cubic-bezier(.43, -0.78, 0, 1.66);
                  }
                }
                svg {
                  .fill {
                    fill: transparent;
                  }
                }
              }
            }
          }
          &--live-board {
            .home-tag {
              top: 16px;
              left: 29px;
            }
            .emblem {
              margin: 0 auto 8px;
            }
            .name {
              width: 70%;
              height: 24px;
              margin-left: 15%;
              display: flex;
              align-items: center;
              justify-content: center;
              > span {
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                text-overflow: ellipsis;
                color: ${props => props.theme.color.modalTxt};
                line-height: 1.3rem;
              }
            }
            .center {
              color: ${props => props.theme.color.disableTxt};
              opacity: 0.3;
              margin: 0 14px;
              transform: translateY(-2px);
              &.overtime-center {
                display: none;
                color: red;
                opacity: 0;
              }
            }
            .match-status-label {
              display: flex;
              align-items: center;
              justify-content: center;
              min-width: 51px;
              height: 20px;
              padding: 0 3px;
              border-radius: 4px;
              font-size: ${props => props.theme.font.medium};
              font-weight: ${props => props.theme.fontW.bold};
              color: ${props => props.theme.color.white};
              background-color: ${props => props.theme.color.modalred};
              &.end {
                color: ${props => props.theme.color.disableTxt};
                background-color: #BEC4CF;
              }
            }
            .soccer-label {
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 3px;
              position: absolute;
              bottom: 100%;
              left: 50%;
              transform: translateX(-50%);
              color: ${props => props.theme.color.disableTxt};
              font-size: 12px;
              font-weight: ${props => props.theme.fontW.bold};
              .timer-icon {
                width: 12px;
                height: 12px;
              }
            }
            .overtime-wrap {
              display: flex;
              align-items: center;
              justify-content: center;
              .overtime {
                width: 100%;
                height: 18px;
                padding: 0 7px;
                text-wrap: nowrap;
                color: ${props => props.theme.color.subColor};
                font-size: 10px;
                font-weight: ${props => props.theme.fontW.bold};
                background: #BEC4CF;
                line-height: 20px;
              }
            }
            &--score {
              height: 36px;
              margin-bottom: 15px;
              .score-num, .center {
                font-size: 30px;
              }
              .center {
                color: ${props => props.theme.color.disableBg};
              }
            }
          }
        }
      }
    }
    //  경기결과 - 배당판
    .dividend-board {
      position: absolute;
      top: 69px;
      left: 50%;
      transform: translateX(-50%);
      ${dividendBoardStyle};
    }
    //  경기결과 - 한줄평
    .comment-wrap {
      padding: 0 20px 12px;
      .comment {
        font-weight: ${props => props.theme.fontW.medium};
        color: ${props => props.theme.color.modalTxt};
        white-space: pre-line;
        text-align: left;
        line-height: 16px;
        background: #E1E4EB;
        border-radius: 14px;
        padding: 10px 34px;
      }
    }
  }

  /* ****************************************** pc ****************************************** */
  &.pc {
    .match-block-body {
      .odds-block-list-content {
        border-radius: 0;
        .odds-block-list--team-btn .odds-block-radio-group .match-btn-collapse .am-accordion-content .am-accordion-content-box {
          border-radius: 0;
        }
      }
      .odds-block-list {
        &--team-info {
          height: 45px;
          line-height: 4.5rem;
        }
        &--date, &--time, &--team-info--name {
          font-size: ${props => props.theme.font.large};
        }
        &--team-info--emblem {
          height: 20px;
          margin-right: 4px;
        }
        &--btn {
          &.detail {
            /* 상세경기 활성화 */
            &.focus {
              .odds-block-list--btn--txt,
              .odds-block-list--btn--num {
                color: ${props => props.theme.color.modalTxt};
              }
              .odds-block-list--btn--num {
                margin-top: 0;
              }
              .odds-block-list--btn--img:not(.arrow) {
                height: 28px;
              }
            }
          }
        }
        &--team-btn {
          .odds-block-radio-group {
            .am-accordion-content {
              max-width: 481px;
              .point-type {
                font-size: ${props => props.theme.font.medium};
              }
            }
            .odds-block-radio-btn {
              height: ${PCMatchBtnH};
              line-height: ${PCMatchBtnH};
              &--team {
                &--type {
                  font-size: ${props => props.theme.font.medium};
                }
                &--num {
                  margin-bottom: -1px;
                  font-size: ${props => props.theme.font.large};
                  height: ${PCMatchBtnH};
                  .underover-ico {
                    width: 10px;
                  }
                }
              }
              /* 배당률 변화 애니메이션 */
              &::before {
                height: ${PCMatchBtnH};
              }
              .rate-change {
                &.left {
                  right: 15px;
                }
                &.right {
                  left: 15px;
                }
                .down-num, .down {
                  top: 25px;
                }
              }
            }
          }
        }
      }
      /* 라이브 매치 */
      &.live {
        .odds-block-list--team-btn .odds-block-radio-group .odds-block-radio-btn:not(.ant-radio-button-wrapper-disabled)::before {
          height: ${PCMatchBtnH};
        }
        .live-match-bg {
          width: 100%;
          height: auto;
        }
        /* 배당률 변화 애니메이션 */
        .rate-change {
          &.left {
            right: 15px;
          }
          &.right {
            left: 15px;
          }
          .down-num, .down {
            top: 25px;
          }
        }
      }
    }
    // 상세 BET PC
    &.match-detail {
      .ant-collapse-item {
        border-radius: 0 !important;
        .ant-collapse-content {
          .ant-collapse-content-box {
            .market-type {
              .outcome-btn-wrap {
                .ant-radio-group {
                  .btn-group {
                    .ant-radio-button-wrapper {
                      height: ${PCMatchBtnH};
                      line-height: ${PCMatchBtnH};
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
// 사용하지않는 코드 (코드 정리 후 삭제예정)
/* Match Col style */
export const Match = (theme: Theme) =>
  css`
    height: auto; /* auto로 해야 하위 내용이 제대로 보임 */
    text-align: center;
    overflow: visible;
    padding-left: 0 !important;
    padding-right: 0 !important;
    .ant-radio-group {
      display: flex;
      justify-content: space-between;
    }
    .ant-radio-button-wrapper, .ant-radio-button-wrapper-disabled:first-of-type, .ant-radio-button-wrapper-disabled:hover {
      width: 41.5%;
      height: ${MatchBtnH};
      padding: 0 4px;
      line-height: ${MatchBtnH};
      text-align: left;
      background-color: ${theme.color.subBg};
      border-left: none;
      border: none;
      border-radius: 50px !important;
      transition: all 0.3s;
      /* 매치업 가운데 버튼 */
      &.center {
        width: 17%;
        margin: 0 4px;
        text-align: center;
        &.handicap {
          background-color: transparent !important;
          .betting-history {
            color: ${theme.color.handicap} !important;
          }
        }
        &.underover {
          background-color: transparent !important;
          .betting-history {
            color: ${theme.color.underover} !important;
          }
        }
      }
    }
    /* ** 날짜/오즈타입 ** */
    &.date-type {
      position: relative;
      width: 100%;
      margin: 6px 0 4px;
      text-align: center;
      line-height: 1rem;
      border: none;
      &.special {
        margin: 6px 6px 4px;
      }
    }
    /* ** 매치업 버튼 ** */
    &.match-btn-wrap {
      width: calc(100% - 74px);
      padding-left: 2px !important;
      padding-right: 2px !important;
      /* 비활성화일때 */
      .ant-radio-button-wrapper:not(:first-of-type)::before {
        background: none;
      }
      .ant-radio-button-wrapper-disabled, .ant-radio-button-wrapper-disabled:first-of-type, .ant-radio-button-wrapper-disabled:hover {
        color: ${theme.color.disableTxt};
        background-color: ${theme.color.disableBg};
        .rate-change {
          display: none;
        }
      }

      /* 매치업 결과 버튼 */
      &.result {
        .ant-radio-button-wrapper-disabled {
          background-color: ${theme.color.subBg};
        }

      }
      /* 핸디캡 / 언더오버 하위 버튼 */
      &.hidden {
        width: 100%;
        padding: 4px;
        .ant-radio-group {
          justify-content: center;
          .ant-radio-button-wrapper {
            width: 35%;
          }
        }
      }
      /* 베팅 내역 */
      &.betting-history {
        width: 100%;
        padding: 0 !important;
        .ant-radio-button-wrapper-disabled, .ant-radio-button-wrapper-disabled:first-of-type, .ant-radio-button-wrapper-disabled:hover {

          background-color: ${theme.color.subBg};
        }
        .team-name {
          color: ${theme.color.themeTxt};
        }
      }
    }

    /* 매치업 상세경기 버튼 */
    &.match-side-btn-wrap {
      width: 30px;
    }

    .ant-radio-button-wrapper:first-of-type {
      border-left: none;
    }
    .ant-radio-button-wrapper.Center {
      width: 15%;
      margin: 0 4px;
    }
    .ant-radio-button-wrapper:not(:first-of-type)::before {
      display: none;
    }
    .ant-radio-button-wrapper-checked,
    .ant-radio-button-wrapper:hover,
    .ant-radio-button-wrapper:focus,
    .ant-radio-button-wrapper:active {
      box-shadow: 0 0 0 0 ${theme.color.select};
    }
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
      background-color: ${theme.color.select};
      border: none;
      box-shadow: none;
    }
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
      background-color: ${theme.color.select};
      border-radius: 15px !important;
      box-shadow: none;
      border: none;
    }
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover::before {
      box-shadow: 0 0 0 0 ${theme.color.select};
    }
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
      box-shadow: none;
    }
    .antd-pro-mobile-src-pages-matchup-index-Sports .ant-collapse > .ant-collapse-item {
      border-bottom: none;
    }

    /* 하위 버튼 스타일 */
    button.disabled {
      color: ${theme.color.disableTxt};
      background-color: ${theme.color.disableBg};
      border: none;
      &::before {
        display: none;
      }
      svg path {
        fill: ${theme.color.disableTxt};
        stroke: ${theme.color.disableTxt};
      }
    }

    /* 스페셜 베팅 후 대기 */
    &.wait {
      .ant-radio-group .ant-radio-button-wrapper-disabled.ant-radio-button-wrapper {
        span,
        p {
          color: ${theme.color.disableTxt};
        }
        &::before {
          content: '';
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: ${MatchBtnH};;
          background-color: ${theme.color.disableBg};
          border-radius: 14px;
          opacity: .5;
        }
      }
      .ant-radio-group .ant-radio-button-wrapper-disabled.ant-radio-button-wrapper.select {
        background-color: ${theme.color.select};
        span,
        p {
          color: ${theme.color.contentsBg};
          &.num {
            color: ${theme.color.yellow};
          }
        }
      }
    }
    /* 스페셜 적중 / 미적중 / 적특 */
    &.match-result {
      .ant-radio-group .ant-radio-button-wrapper-disabled.ant-radio-button-wrapper {
        span,
        p {
          color: ${theme.color.disableTxt};
        }
        &::before {
          content: '';
          z-index: 1;
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: ${MatchBtnH};;
          background-color: ${theme.color.disableBg};
          border-radius: 14px;
          opacity: .5;
        }
      }
      .ant-radio-group .ant-radio-button-wrapper-disabled.ant-radio-button-wrapper.select {
        background-color: ${theme.color.primary};
        span,
        p {
          color: ${theme.color.contentsBg};
          &.num {
            color: ${theme.color.yellow};
          }
        }
      }
      .ant-radio-group .ant-radio-button-wrapper-disabled.ant-radio-button-wrapper.result {
        background-color: ${theme.color.primary};
        svg {
          display: none;
        }
        span,
        p {
          color: ${theme.color.contentsBg};
          &.num {
            color: ${theme.color.yellow};
          }
        }
        &::before {
          content: '';
          display: none;
        }
      }
    }
    /* 스페셜 베팅 내역 */
    &.special-result {
      width: 100%;
    }
    /* 스페셜 매치 결과 내역 */
    &.result-match {
      .ant-radio-group .ant-radio-button-wrapper-disabled.ant-radio-button-wrapper {
        background-color: ${theme.color.subBg};
        span,
        p {
          color: ${theme.color.themeTxt};
          &.num {
            color: ${theme.color.yellow} !important;
          }
        }
      }
      .ant-radio-group .ant-radio-button-wrapper-disabled.ant-radio-button-wrapper.result {
        background-color: ${theme.color.primary};
        span,
        p {
          color: ${theme.color.contentsBg};
        }
      }
    }
    /* live */
    /* 배당률 변화 표시 */
    &.live {
      .ant-radio-button-wrapper:not(:first-of-type)::before {
        background: none;
      }
      .ant-radio-button-wrapper-checked .up-num,
      .ant-radio-button-wrapper-checked .down-num {
        text-shadow: -1px -1px 0 rgba(0, 0, 0, .2),
        1px -1px 0 rgba(0, 0, 0, .2),
        -1px 1px 0 rgba(0, 0, 0, .2),
        1px 1px 0 rgba(0, 0, 0, .2);
      }
      .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
          /* background-color: ${theme.color.primary} !important ; */
      }
      .ant-radio-group .ant-radio-button-wrapper.up {
        z-index: 1;
        &:not(.ant-radio-button-wrapper-disabled)::before {
          z-index: -1;
          content: '';
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: ${MatchBtnH};;
          border: 1px solid ${theme.color.red};
          border-radius: 50px;
          animation: ${ShowAni} 1s alternate forwards;
          animation-iteration-count: infinite;
        }
        &.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
          background-color: ${theme.color.redBg} !important;
        }
      }
      .ant-radio-group .ant-radio-button-wrapper.down {
        z-index: 1;
        &:not(.ant-radio-button-wrapper-disabled)::before {
          z-index: -1;
          content: '';
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: ${MatchBtnH};;
          border: 1px solid ${theme.color.blue};
          border-radius: 50px;
          background-color: none;
          animation: ${ShowAni} 1s alternate forwards;
          animation-iteration-count: infinite;
        }
        &.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
          background-color: #236189 !important;
        }
      }
      /* 라이브 비활성화일때 */
      .ant-radio-button-wrapper-disabled {
        color: ${theme.color.disableTxt};
        background-color: ${theme.color.disableBg};
        .rate-change {
          display: none;
        }
      }
    }
    /* live */

  `
// Match
// 배당률 변화 애니메이션
const CommonNumStyle = css`
  position: relative;
  animation: ${ShowAni} 1s alternate forwards;
`
// 배당률 변화
export const ChangeNum = styled.span`
  position: absolute;
  top: 1px;
  width: 100%;
  line-height: 1rem;
  span {
    font-size: ${props => props.theme.font.tiny};
  }
  .up-num,
  .down-num,
  .up,
  .down {
    ${CommonNumStyle};
    animation-iteration-count: infinite;
  }
  .up-num.live,
  .down-num.live,
  .up.live,
  .down.live {
    ${CommonNumStyle};
    animation-iteration-count: infinite;
  }
  .up-num {
    top: 1px;
    color: ${props => props.theme.color.red} !important;
  }
  .down-num {
    top: 23px;
    margin-left: 4px;
    color: ${props => props.theme.color.blue} !important;
  }
  .up {
    top: 1px;
  }
  .down {
    top: 23px;
  }
  /* 왼쪽 버튼/중앙 버튼 배당률 변화 */
  &.left {
    right: 8px;
    .up-num,
    .down-num {
      float: right;
    }
    .up,
    .down {
      float: right;
      margin-right: 2px;
    }
    &.live-center {

    }
  }
  /* 오른쪽 버튼 배당률 변화 */
  &.right {
    left: 8px;
    .up-num,
    .down-num {
      float: left;
    }
    .up,
    .down {
      float: left;
      margin-left: 2px;
    }
  }
`
// up/down 아이콘
export const UpDownIcoStyle = styled.span`
  position: relative;
  top: 0;
  width: 6px;
`
export const DateSpan = styled.span`
  float: left;
  margin: 0 4px 0 14px;
  color: ${props => props.theme.color.gray};
  font-size: ${props => props.theme.font.small};
`
export const TimeSpan = styled.span`
  float: left;
  color: ${props => props.theme.color.themeTxt} !important;
  font-size: ${props => props.theme.font.small};
`
export const Team = styled.span`
  position: relative;
  display: inline-block;
  top: 1px;
  width: 60%;
  height: ${MatchBtnH};;
  ${LetterSpace};
  &.team-wrap.left {
    float: left;
    .team-name {
      margin: 0 0 0 6%;
      &.special {
        margin: 0 0 0 6%;
      }
    }
  }
  &.team-wrap.right {
    float: right;
    .team-name {
      text-align: right;
      &.special {
        width: 94%;
      }
    }
  }
  /* 매치업 결과 */
  &.result {
    width: 100%;
    &.team-wrap.left {
      .team-name {
        margin: 0 0 0 6%;
      }
    }
    &.team-wrap.right {
      .team-name {
        width: 94%;
      }
    }
  }
  /* 베팅내역 */
  &.history {
    top: 0;
  }
  .team-name {
    position: absolute;
    top: 50%;
    display: inline-block;
    width: 94%;
    ${TxtLimit2};
    transform: translate(0, -50%);
    /* 상세 경기 */
    &.detail {
      width: 60%;
      color: ${props => props.theme.color.gray};
      font-size: ${props => props.theme.font.small};
      &.special {
        width: 48%;
        overflow: visible;
        ${mqMin[1]} {
          width: 80%;
        }
      }
    }
    &.result {
      width: 70%;
    }
  }
`
export const TeamName = styled.span`
  border: 4px solid green;
`
export const TeamIco = styled.span`
  position: relative;
  top: 6px;
  float: left;
  width: 20%;
  img {
    display: block;
    width: 14px;
    height: 14px;
    margin: 0 auto;
  }
  &.right-team-icon {
    float: right;
  }
`
const NumStyle = (props: ThemeProps) =>
  css`
    position: relative;
    top: 1px;
    color: ${props.theme.color.yellow} !important;
    letter-spacing: -0.02rem;
  `
export const Num = styled.span`
  ${NumStyle};
  width: auto;
  min-width: 22%;
  max-width: 35%;
  &.num-left {
    float: right;
    text-align: right;
    margin-right: 4px;
  }
  &.num-right {
    float: left;
    margin-left: 4px;
  }
  /* 매치업 결과 */
  &.match-result {
    color: ${props => props.theme.color.yellow};
  }
  /* 베팅 내역 */
  &.betting-history {
    top: -1px;
  }
`
export const NumCenter = styled.span`
  ${NumStyle};
  text-align: right;
  width: auto;
  &.wdl {
    top: 0;
    &.betting-history {
      top: 1px;
    }
  }
  &:not(.wdl) {
    display: inline-block;
    width: 65%;
    top: 0;
    /* iPad 이상 */
    ${mqMin[3]} {
      max-width: 86px;
    }
    /* iPad 이하 */
    ${mq[3]} {
      max-width: 66px;
    }
  }
  /* modal 기준점 */
  &.point-num {
    display: inline-block;
    width: 100%;
    text-align: center;
    color: ${props => props.theme.color.handicap} !important;
  }
  &.handicap, &.underover {
    color: ${props => props.theme.color.handicap} !important;
  }

  /* 매치업 결과 */
  &.match-result {
    top: 0;
  }
`
export const CenterWrap = styled.div`
  ${ButtonStyles};
  width: calc((100% - 16px) / 3);
  height: auto;
  margin: 0 4px;
  line-height: 1rem !important;
  background: ${props => props.theme.color.TP};
  &.top-wrap {
    position: relative;
    * {
      transition: none !important;
    }
  }
  &.bottom-wrap {
    display: inline-flex;
    justify-content: space-between;
    width: calc(((100% - 16px) / 3) - 24px);
    margin: 0;
    transform: translateY(-2px);
    .point-type {
      flex: 1;
      font-size: ${props => props.theme.font.small};
      color: ${props => props.theme.color.modalSubBg};
      opacity: .3;
      text-align: center;
    }
    .point-num {
      flex: 2;
      text-align: right;
      color: ${props => props.theme.color.underover};
    }
    .empty-area {
      flex: 1;
    }
  }
  /* 핸디캡/언더오버 기준점 모달 */
  &.odds-block-modal {
    width: 100%;
    max-height: 50vh;
    overflow: hidden;
    overflow-y: scroll;
    margin: 0;
    //padding: 8px 13px;
      // background: ${props => props.theme.color.mainColor};
    .odds-block-list--team-btn {
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: center;
      //margin-bottom: 6px;
      .match-type {
        width: 50px;
        color: ${props => props.theme.color.gray};
        font-size: ${props => props.theme.font.small};
        text-align: center;
        .small {
          color: ${props => props.theme.color.gray};
          font-size: ${props => props.theme.font.tiny};
        }
      }
      .odds-block-radio-group {
        display: flex;
        flex: 1;
        justify-content: space-between;
        align-items: center;
        max-width: 100%;
        padding: 0 6px;
        .odds-block-radio-btn {
          width: calc((83% / 2) - 4px);
          height: ${MatchBtnH};
          line-height: ${MatchBtnH};
          padding: 0 12px;
          background: ${props => props.theme.color.mainBg};
          border-radius: 30px;
          border: none;
          /* 버튼 클릭 애니메이션 제거 */
          transition: none;
          /* 기본 라인 제거 */
          &::before {
            display: none;
          }
          &.center {
            .rate-change {
              right: 28px;
            }
          }
          /* 버튼 활성화시 */
          &.ant-radio-button-wrapper-checked {
            background: ${props => props.theme.color.underover};
            box-shadow: none;
            .odds-block-radio-btn--team--type, .odds-block-radio-btn--team--num .rate {
              color: ${props => props.theme.color.subBg};
            }
          }
          /* 버튼 비활성화시 */
          &.ant-radio-button-wrapper-disabled {
            background: ${props => props.theme.color.disableBg};
          }
          /* 배당판 버튼 하위 내용 */
          &--team {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            &--type {
              text-align: center;
              color: ${props => props.theme.color.disableTxt};
              font-size: ${props => props.theme.font.small};
            }
            &--num {
              text-align: right;
              height: ${MatchBtnH};
              .rate {
                display: inline-block;
                max-width: 38px;
                ${TxtLimit};
                color: ${props => props.theme.color.yellow};
              }
            }
            /* 중앙 버튼 */
            &.center {
              .odds-block-radio-btn--team--type, svg, .blank {
                flex: 1;
              }
              .odds-block-radio-btn--team--num {
                flex: 2;
              }
            }
          }
          /* &-team */
        }
      }
      /* match-radio-group */
    }
    /* &-team-btn */
  }
  /* 매치업 결과 하위 내용 */
  .match-result {
    margin-bottom: 10px;
    &:last-of-type {
      margin-bottom: 0;
    }
    &.underover {
      .team-wrap {
        width: 100%;
        .team-name {
          width: 100%;
          padding: 0;
          text-align: center;
        }
      }
    }
    .hidden {
      .ant-radio-button-wrapper {
        padding: 0 4px;
      }
    }
  }
  .am-accordion {
    position: relative;
    margin-top: 24px;
    margin-bottom: -0.5px;
    border: none;
    &::before {
      display: none !important;
    }
  }
  .am-accordion .am-accordion-item .am-accordion-header {
    z-index: 2;
    position: absolute;
    top: -30px;
    left: 0;
    width: 100%;
    height: 31px;
    margin: 0;
    padding: 0;
    background: ${props => props.theme.color.TP} !important;
    border-bottom: none;
    &::after {
      display: none !important;
    }
  }
  .am-accordion-header i {
    display: none !important;
  }
  .am-accordion .am-accordion-item .am-accordion-content .am-accordion-content-box {
    padding: 0;
    margin: 6px 0 10px;
    line-height: 1rem;
    &::after {
      display: none !important;
    }
  }
  .am-accordion .am-accordion-item .am-accordion-content {
    position: relative;
    top: 5px;
    left: -44vw;
    width: 100%;
    text-align: center;
    background: ${props => props.theme.color.contentsBg};
  }
  /* CenterIco 위치 변경으로 코드 먹지 않음 */
  /* .am-accordion-item.am-accordion-item-active ~ span svg {
    transform: rotate(-135deg);
  } */
  .am-accordion-item.am-accordion-item-active div {
    animation: ${ShowHidden} 0.3s ease-in-out;
  }
  // 기준점 모달 스타일 --- 아코디언으로 적용 시 삭제할 코드
  &.modal-style {
    width: 100%;
    max-height: 50vh;
    overflow: hidden scroll;
    margin: 0;
    padding: 8px 0;
    background: rgb(33, 39, 50);
    .odds-block-list {
      &--team-btn {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 6px;
        .point-type {
          display: none;
        }
      }
    }
  }
`
export const CenterIco = css`
  z-index: 1;
  position: absolute;
  top: 12px;
  left: 50%;
  width: 12px;
  background: transparent;
  transition: all 0.3s;
  transform: translate(-50%, 0);
  svg {
    transition: all 0.3s;
  }
`
export const ArrowIcoStyle = styled.span`
  z-index: 1;
  position: absolute;
  top: 13px;
  width: 10px;
  height: 10px;
  &::before {
    z-index: -1;
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: inherit;
    height: inherit;
    transform: translate(-50%, -50%);
    border-radius: 50%;
  }
  &.up,
  &.down {
    svg {
      position: absolute;
      width: 5px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      path {
        fill: ${props => props.theme.color.themeTxt};
      }
    }
  }
  &.up {
    right: -6px;
    svg {
      transform: translate(-50%, -52%);
    }
    &::before {
      background: ${props => props.theme.color.red};
    }
  }
  &.down {
    left: -6px;
    svg {
      transform: translate(-50%, -48%);
    }
    &::before {
      background: ${props => props.theme.color.blue};
    }
  }
`
export const UnderOverIco = styled.span`
  float: left;
  text-align: center;
  svg {
    position: relative;
    width: 8px;
  }
  &.up {
    float: right;
    margin-left: 4px;
    svg {
      path {
        fill: ${props => props.theme.color.red};
      }
    }
  }
  &.down {
    margin-right: 4px;
    svg {
      transform: rotate(180deg);
      path {
        fill: ${props => props.theme.color.blue};
      }
    }
  }
`

export const Score = styled.span`
  position: absolute;
  width: auto;
  font-size: ${props => props.theme.font.medium};
  &.left {
    right: 65.5%;
    text-align: right;
  }
  &.left.overtime {
    right: 65.5%;
  }
  &.right {
    left: 65.5%;
  }
  &.win {
    color: ${props => props.theme.color.red};
  }
  &.lose {
    color: ${props => props.theme.color.disableTxt};
  }
`
export const GamePreviewWrap = styled.div`
  position: relative;
  .match-block-header {
    padding: 0 14px;
    &::before, &::after {
      content: '';
      z-index: -1;
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
      border-bottom: 1px solid ${props => props.theme.color.mainBg};
    }
    &::after {
      bottom: -1px;
      border-color: ${props => props.theme.color.disableBg};
      opacity: .2;
    }
  }
  .match-record-btn {
    position: absolute;
    top: 0;
    left: 50%;
    width: 100%;
    height: 100%;
    transform: translateX(-50%);
    border-radius: 0;
    background: none;
    opacity: 0;
    z-index: 0;
    .btn-bg {
      display: none;
    }
    svg {
      display: none;
    }
  }
  .game-wrap {
    position: relative;
    z-index: 1;
    height: 22px;
    padding: 0 14px;
    line-height: 2.2rem;
    text-align: left;
    background: ${props => props.theme.color.matchTit2};
    overflow: hidden;
    &--sports {
      float: left;
      width: auto;
      margin-right: 5px;
      border: 1px solid pink;
      &-name {
        float: left;
        position: relative;
        top: 1px;
        left: 8px;
      }
    }
    &--tour {
      position: relative;
      top: 1px;
      display: flex;
      flex-wrap: nowrap;
      justify-content: flex-start;
      max-width: 100%;
      border: 1px solid orange;
      &--nation {
        float: left;
        margin: 0 8px 0 0;
      }
      &--txt {
        float: left;
        max-width: 100%;
        margin: 0 4px;
      }
    }
  }
  .game-info-wrap {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    width: 100%;
    height: 36px;
    padding: 0 14px;
    text-align: center;
    * {
      font-size: ${props => props.theme.font.small};
    }
    .team-wrap {
      top: 0;
      width: 28%;
      height: auto;
      line-height: 3.4rem;

      &.left {
        float: left;
        text-align: left;
      }
      &.right {
        float: right;
        text-align: right;
      }
      .emblem {
        top: 10px;
      }
    }
    .center {
      position: relative;
      width: 44%;
      padding-top: 1px;
      .date-wrap {
        position: relative;
        top: 4px;
        width: 100%;
        text-align: center;
      }
      .txt {
        position: absolute;
        left: 50%;
        bottom: 5px;
        width: 100%;
        color: ${props => props.theme.color.btn};
        font-size: ${props => props.theme.font.small};
        transform: translate(-50%, 0);
      }
    }
  }
  /* 핸디캡/언더오버 기준점 modal */
  &.odds-block-modal {
    background: ${props => props.theme.color.mainColor};
    border-bottom: 1px solid ${props => props.theme.color.mainBg};
    &::before {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      width: inherit;
      height: 1px;
      border-bottom: 1px solid #303B49;
    }
    .game-info-wrap {
      height: auto;
      padding: 14px;
    }
    .team-wrap {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex: 1;
      width: auto;
      line-height: initial;
      .team-emblem {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        height: auto;
        max-width: 20px;
        max-height: 20px;
      }
      .team-name {
        position: relative;
        top: initial;
        left: initial;
        transform: translate(0, 0);
        width: 100%;
        text-align: center;
        margin-top: 26px;
      }
    }
    .center {
      width: 16px;
      font-size: ${props => props.theme.font.medium};
      .txt {
        bottom: auto;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: ${props => props.theme.font.title};
      }
    }
    &.pc {
      .game-info-wrap {
        padding: 20px;
      }
      .team-emblem {
        max-width: 30px;
        max-height: 30px;
      }
      .team-name {
        max-width: 138px;
        margin-top: 40px;
        font-size: ${props => props.theme.font.medium};
      }
      .center .txt {
        font-size: ${props => props.theme.font.xlarge};
      }
    }
  }
`
export const MatchTeamInfoWrap = styled.div`
  position: relative;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 110px;
  padding: 12px;
  overflow: hidden;
  .game-info-team {
    position: relative;
    flex: 1;
    display: flex;
    max-width: 120px;
    height: 61px;
    flex-wrap: wrap;
    justify-content: center;
    .home-tag-img {
      position: absolute;
      top: -8px;
      left: 23px;
      width: 20px;
      height: auto;
      &.pc {
        width: 23px;
      }
    }
    .emblem {
      display: block;
      width: auto;
      height: 30px;
      margin: 0 auto;
    }
    .team-name {
      ${TxtLimit2};
      white-space: pre-line; /* 첫번째 줄에도 ... 생략되는 현상 해결 */
      width: calc(100% - 20px);
      max-height: 30px;
      line-height: 1.5rem;
      margin-top: 1px;
      text-align: center;
      color: ${props => props.theme.color.themeTxt};
    }
    &.home {
      margin-right: 50px;
    }
    &.away {
      margin-left: 50px;
    }
  }
  .game-info-center {
    position: absolute;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    //width: 80px;
    min-width: 140px;
    height: 100%;
    line-height: 1.5rem;
    padding-top: 3px;
    text-align: center;
    overflow: visible;
    .date {
      width: 100%;
      margin-bottom: 3px;
      font-size: ${props => props.theme.font.large};
      color: ${props => props.theme.color.modalgray};
    }
    .time {
      width: 100%;
      color: ${props => props.theme.color.themeTxt};
    }
    // 라이브일 경우
    .score {
      display: flex;
      justify-content: center;
      width: 100%;
      height: 20px;
      margin-bottom: 2px;
      color: ${props => props.theme.color.themeTxt};
      .home-score, .away-score {
        position: relative;
        flex: 1;
        font-size: ${props => props.theme.font.xlarge};
        color: ${props => props.theme.color.themeTxt};
        .volleyball-score {
          position: absolute;
          top: -15px;
          left: 0;
          width: 100%;
          display: flex;
          align-items: center;
          &.home {
            justify-content: flex-end;
            .volleyball-score--img {
              margin-left: 4px;
            }
          }
          &.away {
            justify-content: flex-start;
            .volleyball-score--img {
              margin-right: 6px;
            }
          }
          &--img {
            display: inline-block;
            width: 5px;
            height: 5px;
            background: ${props => props.theme.color.themeTxt};
            border-radius: 50%;
          }
        }
      }
      .center {
        margin: 0 9px;
        font-size: ${props => props.theme.font.xlarge};
      }
      .home-score {
        text-align: right;
      }
      .away-score {
        text-align: left;
      }
      .home-score, .away-score {
        &.win {
          color: ${props => props.theme.color.red};
        }
        &.lose {
          color: ${props => props.theme.color.themeTxt};
        }
      }
    }
    .status {
      color: ${props => props.theme.color.modalgray};
    }
    // 현재 보고 있는 경기
    .current-match {
      width: 49px;
      height: 16px;
      line-height: 1.6rem;
      margin-top: 7px;
      text-align: center;
      font-size: ${props => props.theme.font.small};
      color: ${props => props.theme.color.modalTxt};
      background: ${props => props.theme.color.yellow};
      border-radius: 20px;
    }
  }

  // 경기 변경 모달
  &.change-match-modal {
    height: 77px;
    background: ${props => props.theme.color.themeTxt};
    * {
      background: none;
    }
    .match-block-header {
      .tournament-emblem {
        margin-right: 21px;
      }
    }

    .game-info-team {
      .team-name {
        font-size: ${props => props.theme.font.small};
        color: ${props => props.theme.color.modalTxt};
      }
    }
    .game-info-center {
      .date {
        font-size: ${props => props.theme.font.small};
      }
      .time {
        color: ${props => props.theme.color.modalTxt};
      }
      .score {
        color: ${props => props.theme.color.modalTxt};
        .center {
          margin: 0 3px;
        }
        .home-score, .away-score, .center {
          font-size: ${props => props.theme.font.title};
          color: ${props => props.theme.color.modalTxt};
        }
      }
      .status {
        font-size: ${props => props.theme.font.small};
      }
    }
  }
  // 상세 BET 매치요약
  &.detail-bet {
    padding: 16px 0 0 0;
    align-items: flex-start;
    flex-wrap: wrap;
    height: auto;
    .live-detail-bg {
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      width: 100%;
      height: auto;
      background: ${props => props.theme.color.mainBg};
      &--img {
        opacity: .2;
        width: inherit;
        height: inherit;
      }
    }
    .game-info-team {
      height: 79px;
      align-content: flex-start;
      margin-bottom: 18px;
      .emblem {
        height: 45px;
        margin: 4px auto 0;
      }
      .team-name {
        margin-top: 6px;
      }
    }
    .game-info-center {
      height: 79px;
      padding-top: 5px;
      .date {
        color: ${props => props.theme.color.disableTxt2};
      }
      .time {
        font-size: ${props => props.theme.font.large};
      }
      .dividend-board {
        margin-top: 7px;
        ${dividendBoardStyle};
        border-color: #50607033;
        box-shadow: none;
        span {
          :nth-child(2) {
            border-color: #50607033 !important;
          }
        }
      }
    }
    // 경기결과
    &.result-page {
      padding: 26px 0 0;
      .game-info-center {
        height: auto;
        margin-top: -10px;
        padding-top: 1px;
        .date-info-wrap {
          width: 100%;
          margin-bottom: 10px;
          .date, .time {
            display: inline-block;
            width: auto;
            font-size: ${props => props.theme.font.medium};
            color: ${props => props.theme.color.btn};
            margin: 0;
          }
          .time {
            margin-left: 4px;
          }
        }
        .score {
          margin: -3px 0 5px;
          height: 30px;
          align-items: center;
          &.live {
            margin-top: 25px;
          }
          .home-score, .away-score {
            font-size: 32px;
            &.win {
              color: ${props => props.theme.color.red};
            }
          }
          .center {
            width: 32px;
            height: 18px;
            color: ${props => props.theme.color.disableTxt};
            position: relative;
            &:empty::after {
              content: '종료';
              display: flex;
              align-items: center;
              justify-content: center;
              position: absolute;
              font-size: ${props => props.theme.font.small};
              font-weight: ${props => props.theme.fontW.bold};
              top: 2px;
              left: 50%;
              transform: translateX(-50%);
              white-space: nowrap;
              width: 100%;
              height: 100%;
              border-radius: 4px;
              background: ${props => props.theme.color.subColor2};
            }
          }
        }
        .dividend-board {
          margin-top: 0;
        }
      }
    }
  }
`
// 라이브 카운트
export const LiveCountWrap = styled.div`
  z-index: 101;
  position: fixed;
  bottom: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  height: auto;
  padding: 5px 14px;
  line-height: 3rem;
  text-align: center;
  background: ${props => props.theme.color.mainBg};
  &::before {
    content: '';
    z-index: -1;
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    opacity: .5;
    background: ${props => props.theme.color.mainBg};
  }
  .count-wrap {
    width: 100%;
    &--num {
      display: inline-block;
      width: 46px;
      height: 20px;
      margin-right: 12px;
      line-height: 2rem;
      color: ${props => props.theme.color.modalTxt};
      background: ${props => props.theme.color.modalBg};
      border-radius: 50px;
      text-align: center;
    }
  }
`
// /////////////////////////////////////// new
// export const MatchupAccordionWrap = styled.div`
//   margin-bottom: 165px;
//   padding-bottom: ${NavBottomPadding};
//   border: 1px solid green;
//   .ant-collapse .ant-collapse-item {
//     margin-bottom: 1px;
//     .ant-collapse-header {
//       height: 39px;
//       padding: 0 14px;
//       background: ${props => props.theme.color.mainColor};
//       .arrow {
//         display: none;
//       }
//     }
//     .ant-collapse-content-box {
//       padding: 0;
//     }
//   }
// `

// export const MatchupHeader = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   line-height: 3.9rem;
//   .market-info {
//     display: flex;
//     height: 39px;
//     .market-info--team--name {
//       color: #2ECADB;
//     }
//     &--btn {
//       z-index: 0;
//       width: 42px;
//       height: 100%;
//       margin-left: -14px;
//       margin-right: -7px;
//       text-align: center;
//       background: none;
//       svg {
//         width: 14px;
//         height: auto;
//         margin-top: 1px;
//         transition: all .3s;
//         path {
//           fill: ${props => props.theme.color.themeTxt};
//         }
//       }
//       &.show {
//         svg path {
//           fill: ${props => props.theme.color.underover};
//         }
//       }
//     }
//   }
//   // 상세 BET 즐겨찾기
//   .detail-bet-favorites-btn {
//     z-index: 0;
//     display: inline-flex;
//     justify-content: center;
//     align-items: center;
//     width: 39px;
//     height: 39px;
//     margin-right: -4px;
//     background: none;
//     .btn-bg {
//       position: absolute;
//       top: 50%;
//       left: 50%;
//       transform: translate(-50%, -50%);
//       width: 27px;
//       height: 27px;
//       border-radius: 50%;
//       background: ${props => props.theme.color.mainBg};
//       overflow: hidden;
//     }
//     svg {
//       position: relative;
//       width: 14px;
//       height: auto;
//       path {
//         &.fill {
//           fill: ${props => props.theme.color.disableBg};
//         }
//       }
//     }
//     // 즐겨찾기 활성화
//     &.active {
//       svg {
//        path {
//           &.fill {
//             fill: ${props => props.theme.color.yellow};
//           }
//         }
//       }
//     }
//   }
// `
// const rateUpAni = (props:ThemeProps) => keyframes`
//   100% {
//     color: ${props.theme.color.red};
//   }
// `
// const rateDownAni = (props:ThemeProps) => keyframes`
//   100% {
//     color: ${props.theme.color.blue};
//   }
// `
export const CharacterToolTip = styled.div`
  z-index: 1;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-height: 0;
  transition: max-height .3s cubic-bezier(.69, .05, .32, 1);
  overflow: hidden;
  .bg {
    z-index: -1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${props => props.theme.color.btn};
    opacity: .3;
  }
  .tooltip-img {
    width: 56px;
    height: 56px;
    margin: 14px;
    transform: translateZ(0);
  }
  .tooltip-box {
    flex: 1;
    line-height: 1.8rem;
    padding: 14px 14px 14px 4px;
    margin: 2px 0;
    text-align: left;
    &--txt {
      margin-bottom: 0;
      font-size: ${props => props.theme.font.small};
      font-weight: ${props => props.theme.fontW.medium};
      color: ${props => props.theme.color.themeTxt};
      white-space: pre-wrap;
      &.bottom {
        margin-top: 4px;
      }
    }
  }
  &.show {
    max-height: 402px; /* 너비 360에서 최대 20줄까지 보이도록 */
  }
  // 동일 경기 선택 모달
  &.same-match-modal {
    align-items: center;
    padding: 12px 32px 12px 16px;
    .tooltip-box {
      flex: 1;
      &--txt {
        font-size: ${props => props.theme.font.medium};
      }
    }
  }
`
// // 상세 BET 배당판 버튼
// export const MatchBtnWrap = styled.div`
//   .outcome-name {
//     display: flex;
//     justify-content: space-between;
//     width: 100%;
//     height: 24px;
//     line-height: 2.4rem;
//     text-align: center;
//     background: ${props => props.theme.color.modalSubBg};
//     &--txt {
//       flex: 1;
//       padding: 0 6px;
//       color: ${props => props.theme.color.matchTit1};
//       font-weight: ${props => props.theme.fontW.medium};
//       ${TxtLimit};
//     }
//     &.point  {
//       padding-left: 88px; /* market-point 만큼 여백 */
//     }
//   }
//   .outcome-btn-wrap {
//     display: flex;
//     align-items: center;
//     width: 100%;
//     text-align: center;
//     .btn-group {
//       display: flex;
//       width: 100%;
//       // 기준점
//       .match-point {
//         width: 88px;
//         min-width: 88px;
//         height: ${MatchCommonH};
//         line-height: ${MatchCommonH};
//         margin: 1px 0 0 1px;
//         color: ${props => props.theme.color.tabBg};
//         font-weight: ${props => props.theme.fontW.medium};
//         background: ${props => props.theme.color.modalSubBg};
//       }
//     }
//   }
//   .market-type {
//     display: flex;
//     flex-wrap: wrap;
//     background: ${props => props.theme.color.modalDarkBg};
//     .ant-radio-group {
//       display: flex;
//       flex-wrap: wrap;
//       flex: 1;
//       margin-bottom: 1px;
//       .ant-radio-button-wrapper {
//         height: ${MatchCommonH};
//         line-height: ${MatchCommonH};
//         border: none;
//         border-radius: 0;
//         margin: 1px 0 0 1px;
//         background: ${props => props.theme.color.modalBg};
//         transition: none;
//         // 택스트 + 배당 case
//         .radio-button-outcome-name {
//           float: left;
//           color: ${props => props.theme.color.tabBg};
//           font-weight: ${props => props.theme.fontW.medium};
//           text-overflow: ellipsis;
//           white-space: nowrap;
//           word-wrap: normal;
//           width: 50%;
//           text-align: left;
//           overflow: hidden;
//         }
//         .radio-button-rate {
//           font-size: ${props => props.theme.font.large};
//           color: ${props => props.theme.color.modalOrange};
//           &.float {
//             float: right;
//           }
//           // 배당 변화
//           // &.rate-up {
//           //   animation: ${rateUpAni} 2s 1;
//           //   animation-delay: 2s;
//           // }
//           // &.rate-down {
//           //   animation: ${rateDownAni} 2s 1;
//           //   animation-delay: 2s;
//           // }
//         }
//         .radio-button-lock {
//           display: none;
//           position: absolute;
//           top: 50%;
//           left: 50%;
//           transform: translate(-50%,-50%);
//           width: 10px;
//           height: 13px;
//         }
//       }
//       // 클릭 시
//       .ant-radio-button-wrapper-checked {
//         z-index: 0;
//         border: none;
//         background: ${props => props.theme.color.underover};
//         box-shadow: none;
//         outline: none;
//         &::before {
//           display: none;
//         }
//         .radio-button-rate {
//           color: ${props => props.theme.color.subBg};
//         }
//       }
//       .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
//         box-shadow: none;
//       }
//       .ant-radio-button-wrapper:not(:first-of-type)::before {
//         background: none;
//       }
//       //비활성화
//       .ant-radio-button-wrapper-disabled {
//         background: ${props => props.theme.color.modalBg};
//         .radio-button-outcome-name, .radio-button-rate {
//           display: none;
//         }
//         .radio-button-lock {
//           display: block;
//         }
//       }
//       &.button-free {
//          flex:1;
//       }
//       &.button-2ways {
//         .ant-radio-button-wrapper {
//           width: calc(50% - 1px); /* 여백만큼 빼주기 */
//         }
//       }
//       &.button-3ways {
//         .ant-radio-button-wrapper {
//           width: calc((100% / 3) - 1px);/* 여백만큼 빼주기 */
//         }
//       }
//     } /* ant-radio-group */
//   } /* market-type */
//
//   &.pc {
//     .outcome-name {
//       &.point  {
//         padding-left: 100px; /* market-point 만큼 여백 */
//       }
//     }
//     .btn-group {
//       .match-point {
//         width: 100px;
//         min-width: 100px;
//       }
//     }
//   }
// `
// 선택한 경기 리스트
export const SelectMatchListWrap = styled.div`
  padding-top: 12px;
  border-radius: 6px;
  // 종목 아이콘
  img {
    width: 16px;
    height: 16px;
    margin: 1px 7px 0 12px;
  }
  .match-team {
    display: flex;
    margin-bottom: 6px;
    &--name {
      ${TxtLimit};
      max-width: 70%;
      text-align: left;
      font-weight: ${props => props.theme.fontW.medium};
      color: ${props => props.theme.color.modalTxt};
    }
    &--vs {
      margin: 0 4px;
      color: ${props => props.theme.color.modalTxt};
    }
  }
  .match-type {
    margin: 0 0 8px 31px;
    font-weight: ${props => props.theme.fontW.medium};
    color: ${props => props.theme.color.modalTxt};
    text-align: left;
  }
  .select-wrap {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 32px;
    line-height: 3.2rem;
    padding: 0 31px;
    background: ${props => props.theme.color.modalSubBg};
    .point {
      color: ${props => props.theme.color.modalTxt};
    }
    .value {
      color: ${props => props.theme.color.modalOrange};
      text-align: right;
    }
  }
`
const VersusEmblemStyle = props => css`
  height: ${props.emblemSize}px;
`
export const MatchVersusWrap = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  max-width: calc(100% - 27px);
  height: inherit;
  .team, .center {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
  }
  .team {
    flex: 1;
    max-width: calc((100% - 65px) / 2);
  }
  .center {
    position: relative;
    width: 65px;
  }
  .emblem {
    width: auto;
    ${VersusEmblemStyle};
    margin-bottom: 4px;
  }
  .team-name {
    ${TxtLimit};
    max-width: 100%;
    color: ${props => props.theme.color.modalTxt};
  }
  .vs {
    z-index: -1;
    opacity: .4;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 48px;
    color: ${props => props.theme.color.modalBg};
  }
  .date {
    color: ${props => props.theme.color.disableTxt2};
    font-weight: ${props => props.theme.fontW.medium};
  }
  .time {
    color: ${props => props.theme.color.modalTxt};
    font-weight: ${props => props.theme.fontW.medium};
  }
`

export const MatchupPickPopoverWrap = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  .item {
    width: 54px;
    height: auto;
    border-radius: 7px;
    overflow: hidden;
    &:not(:last-of-type) {
      margin-bottom: 6px;
    }
    img {
      width: inherit;
      height: auto;
    }
  }
`

export const MatchTeamCommonWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 0 0 0;
  .team-info-item {
    position: relative;
    flex: 1;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    max-width: calc((100% - 70px) / 2);
    &:nth-of-type(2) {
      display: flex;
      width: 125px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      span {
        min-width: 50%;
        font-size: 32px;
        text-align: left;
        padding: 0 0 0 9px;
        &:nth-child(1) {
          text-align: right;
          padding: 0 9px 0 0;
        }
      }
    }
    .emblem {
      width: auto;
      height: 45px;
    }
    .team {
      ${TxtLimit};
      display: inline-block;
      max-width: 85%;
      margin-top: 3px;
    }
    .home-tag-img {
      //position: absolute;
      //top: -2px;
      //left: calc(50% - 24px);
      //transform: translateX(-50%);
      //width: auto;
      //height: 21px;
      ::after {
        content: '홈';
        display: block;
        position: absolute;
        top: -2px;
        left: calc(50% - 24px);
        transform: translateX(-50%);
        color: ${props => props.theme.color.themeTxt};
        background-color: ${props => props.theme.color.accordion2};
        width: 22px;
        height: 22px;
        border-radius: 50%;
        line-height: 1.8rem;
        border: 2px solid ${props => props.theme.color.themeTxt};
        font-size: 12px;
      }
    }
    .score {
      &.win {
        color: ${props => props.theme.color.red};
      }
    }
    .vs-bg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      //opacity: .08;
      //font-size: 74px;
      color: ${props => props.theme.color.btn};
      ::before {
        content: '';
        display: block;
        position: absolute;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        top: 4px;
        left: 50%;
        transform: translateX(-50%);
        background-color: ${props => props.theme.color.modalSubBg2};
      }
      ::after {
        content: '';
        display: block;
        position: absolute;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        top: -6px;
        left: 50%;
        transform: translateX(-50%);
        background-color: ${props => props.theme.color.modalSubBg2};
      }
    }
    .date {
      line-height: 1rem;
      color: ${props => props.theme.color.disableTxt2};
    }
  }
`
const sportIconSize = '14px'
const soccerTimeSize = '52px'
const newSoccerTimeSize = '40px'
// const baseballTimeSize = '52px'
export const TimeLineWrap = styled.div`
  width: auto;
  //max-height: 55vh;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  &.timeline-none {
    height: 16px;
  }
  // 축구타임라인 - match time이 존재하지 않는 경우 스타일 [이슈링크](https://task.zempublic.co.kr/view.php?id=9309)
  &.soccer-timeline-disabled {
    height: 38px !important;
    .am-tabs-default-bar-content {
      .soccer-tab-item {
        cursor: default !important;
        .num {
          background: ${props => props.theme.color.modalgray} !important;
        }
        .sport-ico {
          opacity: 1 !important;
          &-active {
            opacity: 0 !important;
          }
        }
      }
    }
    .am-tabs-content-wrap {
      display: none;
    }
  }
  // 축구 타임라인팝업카드 -> 카드수 계산 안내 버튼
  .card-count-guide-btn {
    position: absolute;
    top: 0;
    width: 86px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: none;
    margin: 0 14px 0 calc(100% - 100px);
    color: ${props => props.theme.color.disableTxt};
    font-size: ${props => props.theme.font.medium};
    font-weight: ${props => props.theme.fontW.bold};
    z-index: 1;
    .card-count-guide-icon {
      width: auto;
      height: 14px;
    }
  }
  svg {
    width: 12px;
    height: auto;
    transform: translate3d(0, 0, 0);
  }
  .red-card {
    width: auto;
    height: 14px;
    .card {
      fill: ${props => props.theme.color.red};
    }
  }
  .blackout {
    opacity: 0;
  }
  .timeline {
    position: relative;
    &--basic, &--line {
      .top-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 30px;
        padding: 0 18px;
        .team-info {
          li {
            display: inline-flex;
            align-items: center;
            margin-right: 10px;
            &:last-of-type {
              margin-right: 0;
            }
          }
          svg {
            margin-right: 2px;
          }
        }
      }
      .match-contents {
        svg {
          transform: translate3d(0, 2px, 0);
        }
        .match-time {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 24px;
          color: ${props => props.theme.color.modalTxt};
          font-weight: ${props => props.theme.fontW.medium};
          background: ${props => props.theme.color.modalBg};
          .score {
            margin: 0 4px;
            .center {
              margin: 0 4px;
            }
            .win {
              color: ${props => props.theme.color.red};
            }
          }
        }
        .match-history {
          display: flex;
          flex-flow: column;
          margin-bottom: 12px;
          padding-top: 14px;
          overflow: hidden;
          background-color: ${props => props.theme.color.modalBg};
          &::after {
            content: '';
            display: block;
            position: absolute;
            top: 14px;
            left: 50%;
            transform: translateX(-50%);
            width: 4px;
            height: 4px;
            background: ${props => props.theme.color.modalSubBg};
            border-radius: 50%;
          }
          &--item {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding: 9px;
            svg {
              margin: 3px 6px 0;
            }
            .player {
              flex: 1;
              padding: 0 4px;
              font-size: ${props => props.theme.font.small};
              font-weight: ${props => props.theme.fontW.medium};
              .score-value {
                margin-left: 4px;
                font-size: ${props => props.theme.font.small};
                font-weight: ${props => props.theme.fontW.medium};
                color: ${props => props.theme.color.modalyellow};
              }
              .assist-player {
                display: flex;
                margin-top: -2px;
                font-size: ${props => props.theme.font.small};
                font-weight: ${props => props.theme.fontW.medium};
                color: ${props => props.theme.color.gray};
              }
            }
          }
        }
      }
    }
    &--basic {
      .match-contents {
        .match-history {
          position: relative;
          padding-top: 0;
          &::after {
            top: 0;
          }
          &--item {
            min-height: 24px;
            padding: 0;
            .sport-ico {
              z-index: 1;
              position: relative;
              display: inline-block;
              width: ${sportIconSize};
              height: ${sportIconSize};
            }
            .time {
              z-index: 1;
              display: inline-block;
              width: ${soccerTimeSize};
              height: 24px;
              padding-left: 3px;
              border-radius: 12px;
              background-color: #eee;
              border: 1px solid #c9c9c9;
              text-align: center;
              line-height: 2.3rem;
              font-weight: ${props => props.theme.fontW.bold};
              &.icehockey {
                padding-left: 1px;
              }
            }
            .player {
              .name {
                width: calc(100% - 20px);
              }
            }
            &.home-team {
              flex-flow: row-reverse;
              .player, .assist-player {
                justify-content: flex-end;
                text-align: right;
                display: inline-flex;
                align-items: flex-end;
                white-space: nowrap;
                .name {
                  display: inline-block;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  transform: translateX(-4px);
                  font-weight: ${props => props.theme.fontW.medium};
                }
              }
            }
            &.away-team {
              justify-content: flex-end;
              .player {
                text-align: left;
                display: inline-flex;
                align-items: flex-end;
                white-space: nowrap;
                .name {
                  display: inline-block;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  transform: translateX(4px);
                  font-weight: ${props => props.theme.fontW.medium};
                }
              }
            }
            &.same-round {
              padding-top: 0;
              padding-bottom: 0;
              &.home-team {
                padding-right: ${soccerTimeSize};
              }
              &.away-team {
                padding-left: ${soccerTimeSize};
              }
            }
          }
        }
      }
      &.common {
        .match-contents {
          position: relative;
          display: flex;
          .match-history {
            display: inline-flex;
            flex: 1;
            overflow: visible;
            margin-top: 14px;
            &::after {
              display: none;
            }
            &:first-of-type {
              &::before {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                right: 0;
                width: 1px;
                height: 100%;
                background: ${props => props.theme.color.modalSubBg};
              }
            }
            &:last-of-type {
              &::before {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                left: -3px;
                width: 5px;
                height: 5px;
                border-radius: 50%;
                background: ${props => props.theme.color.modalSubBg};
              }
            }
            &--item {
              margin: 1px 0;
              &.home-team {
                margin-right: calc(-${soccerTimeSize} / 2);
              }
              &.away-team {
                margin-left: calc(-${soccerTimeSize} / 2);
              }
              &.empty {
                .sport-ico {
                  visibility: hidden;
                }
              }
              &.period-end {
                margin-bottom: 18px;
              }
            }
          }
        }
      }
      &.soccer {
        margin-top: 14px;
        .match-contents {
          .empty-wrap {
            &--ico {
              padding: 20px 0 10px;
            }
            &--txt {
              color: ${props => props.theme.color.gray};
            }
          }
          .match-history {
            position: relative;
            &--item {
              display: flex;
              align-items: center;
              min-height: initial;
              padding: 9px;
              &:first-of-type {
                padding-top: 12px;
              }
              &::before {
                content: '';
                display: block;
                position: absolute;
                bottom: 70%;
                left: 50%;
                transform: translateX(-50%);
                width: 1px;
                height: 60%;
                background: ${props => props.theme.color.modalSubBg};
              }
              .player {
                &.card {
                  width: 80px;
                }
                .sport-ico {
                  z-index: 1;
                  position: relative;
                  display: inline-block;
                  width: ${sportIconSize};
                  height: ${sportIconSize};
                  &.card {
                    width: 18px;
                    height: 18px;
                    .sport-ico {
                      width: 100%;
                      height: auto;
                    }
                    &:last-child {
                      margin-left: -4px;
                    }
                  }
                }
              }
              .time {
                z-index: 1;
                display: inline-block;
                width: ${newSoccerTimeSize};
                height: 24px;
                padding-left: 3px;
                border-radius: 12px;
                background-color: #eee;
                border: 1px solid #c9c9c9;
                text-align: center;
                line-height: 2.3rem;
                font-weight: ${props => props.theme.fontW.bold};
                &.icehockey {
                  padding-left: 1px;
                }
              }
              &.home-team {
                flex-flow: row-reverse;
                padding-right: calc((100% - ${newSoccerTimeSize}) / 2);
                .player, .assist-player {
                  justify-content: flex-end;
                  text-align: right;
                  display: inline-flex;
                  align-items: flex-start;
                  white-space: nowrap;
                  .name {
                    display: inline-block;
                    width: 80px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    transform: translateX(-4px);
                    font-weight: ${props => props.theme.fontW.medium};
                  }
                }
              }
              &.away-team {
                justify-content: flex-end;
                padding-left: calc((100% - ${newSoccerTimeSize}) / 2);
                .player {
                  text-align: left;
                  display: inline-flex;
                  align-items: flex-start;
                  white-space: nowrap;
                  .sport-ico {
                    &.card:nth-of-type(2) {
                      margin-left: -4px;
                    }
                  }
                  .name {
                    display: inline-block;
                    width: 90px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    transform: translateX(4px);
                    font-weight: ${props => props.theme.fontW.medium};
                  }
                }
              }
            }
            &--item:first-of-type {
              &::before {
                top: 0;
              }
            }
          }
        }
      }
    }
    &--table {
      position: relative;
      margin-top: 18px;
      width: 100%;
      overflow-x: auto;
      overscroll-behavior: none;
      .table {
        width: auto;
        max-width: 100%;
        border-collapse: separate;
        border-spacing: 0;
        border-top: 1px solid ${props => props.theme.color.modalBg};
        &--head {
          background-color: rgba(221, 221, 221, 0.4);
          & tr {
            > th.fixed.left + th.round {
              padding-left: 10px;
            }
            > th.round:has(+ th.fixed.right) {
              padding-right: 10px;
            }
          }
          .round {
            padding: 0 4px;
            text-align: center;
            font-weight: ${props => props.theme.fontW.medium};
            &.total {
              font-weight: ${props => props.theme.fontW.bold};
            }
            &.overtime {
              min-width: 32px;
            }
            &.icehockey {
              padding: 0;
            }
          }
        }
        & th {
          border-bottom: 1px solid ${props => props.theme.color.modalBg};
          white-space: nowrap;
          font-weight: ${props => props.theme.fontW.medium};
          height: 28px;
          color: ${props => props.theme.color.modalgray};
          &.team-name {
            position: relative;
            width: 90px;
            &::before {
              content: '';
              display: block;
              position: absolute;
              top:0;
              width: 100%;
              height: 100%;
              left: 0;
              border-right: 1px solid ${props => props.theme.color.modalBg};
            }
          }
          &.fixed {
            position: sticky;
            z-index: 1;
            background-color: ${props => props.theme.color.themeTxt};
            &::before {
              content: '';
              position: absolute;
              top:0;
              width: 100%;
              height: 100%;
              left: 0;
              background-color: rgba(221, 221, 221, 0.4);
              z-index: -1;
            }
            &.more::after {
              content: '';
              position: absolute;
              display: block;
              top: 0;
              width: 16px;
              height: 80px;
              background: linear-gradient(270deg, rgba(221, 221, 221, 0.8) 10.35%, rgba(221, 221, 221, 0) 84.99%);
              mix-blend-mode: multiply;
              z-index: 5;
            }
            &.left {
              width: 77px;
              left: 0;
              &::before {
                border-right: 1px solid ${props => props.theme.color.modalBg};
              }
              &::after {
                right: -16px;
                left: auto;
                transform: rotate(180deg);
              }
            }
            &.right {
              right: 0;
              width: 48px;
              &::before {
                border-left: 1px solid ${props => props.theme.color.modalBg};
              }
              &::after {
                right: auto;
                left: -16px;
                transform: rotate(0deg);
              }
            }
          }
        }
        &--body {
          & tr {
            &:first-of-type {
              td {
                padding: 5px 3px 4px 3px;
                &.fixed.left {
                  padding: 5px 12px 4px 12px;
                }
              }
            }
            &:last-of-type {
              td {
                padding: 0 3px 8px 3px;
                &.fixed.left {
                  padding: 0 12px 8px 12px;
                }
              }
            }
            > td.team-name + td.score {
              padding-left: 10px;
            }
            > td.score:has(+ td.total),
            > td.score:has(+ td.combined-total-column),
            &:not(:first-of-type) > td.score:last-of-type {
              padding-right: 10px;
            }
          }
          & td {
            white-space: nowrap;
            line-height: normal;
            &.fixed {
              position: sticky;
              z-index: 1;
              background-color: ${props => props.theme.color.themeTxt};
              &::after {
                content: '';
                position: absolute;
                top: 0;
                width: 1px;
                height: 100%;
                background-color: ${props => props.theme.color.modalBg};
              }
              &.left {
                left: 0;
                &::after {
                  right: 0;
                  left: auto;
                }
              }
              &.right {
                right: 0;
                padding: 0;
                &::after {
                  left: 0;
                  right: auto;
                }
              }
            }
          }
          .team-name {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 60px;
            padding-right: 10px;
            font-weight: ${props => props.theme.fontW.medium};
            text-align: left;
          }
          .score {
            width: auto;
            text-align: center;
            font-weight: ${props => props.theme.fontW.medium};
            padding: 0 3px;
            &.win {
              color: ${props => props.theme.color.red};
            }
            &.total {
              font-weight: ${props => props.theme.fontW.bold};
            }
          }
          .combined-total-wrap {
            display: flex;
            align-items: stretch;
            &::after {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: 1px;
              height: 100%;
              background-color: ${props => props.theme.color.modalBg};
            }
            .team-totals {
              display: flex;
              flex-direction: column;
              flex: 1;
              .score {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 33px;
                padding: 5px 3px 4px 3px;
                font-weight: ${props => props.theme.fontW.bold};
                &:last-of-type {
                  padding: 0 3px 8px 3px;
                }
              }
            }
            .overall-total {
              position: relative;
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 33px;
              padding: 17px 3px 20px 3px;
              &::after {
                content: '';
                position: absolute;
                top: -1px;
                left: 0;
                width: 1px;
                height: 100%;
                background-color: ${props => props.theme.color.modalBg};
              }
            }
          }
        }
        &:has(.combined-total-wrap) {
          .fixed {
            width: 58px;
          }
          & tr:first-of-type {
            td.fixed.left {
              padding: 5px 9px 4px 12px;
            }
          }
        }
        &.volleyball {
          .table--head {
            .round {
              min-width: 38px;
            }
          }
        }
      }
      &.baseball {
        th.fixed.left {
          width: 58px;
        }
        tr:first-of-type {
          td.fixed.left {
            padding: 5px 10px 4px 12px;
          }
          td.score:last-child {
            padding: 5px 19px 4px 3px;
          }
        }
        tr:last-of-type {
          td.fixed.left {
            padding: 0 10px 8px 12px;
          }
          td.score:last-child {
            padding: 0 19px 8px 3px;
          }
        }
        tr > th.fixed.left + th.round {
          min-width: 37px;
          padding-left: 12px;
        }
        tr > td.team-name + td.score {
          padding-left: 12px;
        }
        th.round {
          min-width: 25px;
          padding: 0 3px;
          &:last-child {
            width: 44px;
            padding-right: 19px;
          }
        }
        th.fixed.left {
          width: 58px;
          &.more-left {
            &::after {
              content: '';
              position: absolute;
              display: block;
              top: 0;
              right: -16px;
              left: auto;
              width: 16px;
              height: 80px;
              background: linear-gradient(270deg, rgba(221, 221, 221, 0.8) 10.35%, rgba(221, 221, 221, 0) 84.99%);
              mix-blend-mode: multiply;
              transform: rotate(180deg);
              z-index: 5;
            }
            &.pc::after {
              left: 60px;
              right: auto;
            }
          }
          &.more-right {
            &::after {
              content: '';
              position: absolute;
              display: block;
              top: 0;
              left: auto;
              right: calc(-100vw + 40px + 100%); /* 모달 끝에 도달 */
              width: 16px;
              height: 80px;
              background: linear-gradient(270deg, rgba(221, 221, 221, 0.8) 10.35%, rgba(221, 221, 221, 0) 84.99%);
              mix-blend-mode: multiply;
              transform: rotate(0deg);
              z-index: 5;
            }
            &.pc::after {
              left: 304px;
              right: auto;
            }
          }
        }
        tr:first-of-type {
          td.fixed.left {
            padding: 5px 10px 4px 12px;
          }
          td.score:last-child {
            padding: 5px 19px 4px 3px;
          }
        }
        tr:last-of-type {
          td.fixed.left {
            padding: 0 10px 8px 12px;
          }
          td.score:last-child {
            padding: 0 19px 8px 3px;
          }
        }
        tr > th.fixed.left + th.round {
          min-width: 37px;
          padding-left: 12px;
        }
        tr > td.team-name + td.score {
          padding-left: 12px;
        }
        th.round {
          min-width: 25px;
          padding: 0 3px;
          &:last-child {
            width: 44px;
            padding-right: 19px;
          }
        }
        .overtime {
          min-width: auto !important;
        }
        .score {
          min-width: 24px;
        }
        .round {
          padding: 0;
        }
      }
      &.icehockey,
      &.soccer {
        tr:first-of-type {
          td.fixed.left {
            padding: 5px 3px 4px 14px;
          }
          td.score:last-child {
            padding: 5px 19px 4px 3px;
          }
        }
        tr:last-of-type {
          td.fixed.left {
            padding: 0 3px 8px 14px;
          }
          td.score:last-child {
            padding: 0 19px 8px 3px;
          }
        }
        tr > th.team-name + th.round {
          padding-left: 14px;
        }
        tr > td.team-name + td.score {
          padding-left: 14px;
        }
        th.round {
          padding: 0 3px;
        }
        .overtime {
          min-width: auto !important;
        }
        .score {
          min-width: 24px;
        }
        .round {
          padding: 0;
        }
      }
      &.icehockey,
      &.soccer {
        .table {
          table-layout: fixed;
        }
        tr:first-of-type {
          td.fixed.left {
            padding: 5px 12px 4px 12px;
          }
          td.score:last-child {
            padding: 5px 0 4px 0;
          }
        }
        tr:last-of-type {
          td.fixed.left {
            padding: 0 12px 8px 12px;
          }
          td.score:last-child {
            padding: 0 0 8px 0;
          }
        }
        tr > th.team-name + th.round {
          padding-left: 3px;
        }
        tr > td.team-name + td.score {
          padding-left: 3px;
        }
        th.round {
          padding: 0 3px;
        }
        .overtime {
          min-width: auto !important;
        }
        .score {
          min-width: 24px;
        }
        .round {
          padding: 0;
        }
      }
      }
      }
      &.table-tennis {
        overflow-x: auto;
        & th {
          &.screen-out {
            line-height: 3rem;
            text-align: center !important;
          }
        }
        & th:first-of-type,
        & td:first-of-type {
          background-color: ${props => props.theme.color.themeTxt};
          position: absolute;
          left: 0;
          padding-left: 12px;
          min-width: 92px;
          text-align: left;
          z-index: 1;
        }
        & th:not(:first-of-type),
        & td:not(:first-of-type) {
          transform: translateX(90px);
          min-width: 41px;
        }
        & th {
          &.round {
            line-height: 3rem;
          }
        }
      }
      // 농구 타임라인
      
    &.icehockey {
      .table {
        background: red;
      }
    }
  }
  
  .timeline--table--basketball {
    display: flex;
    justify-content: space-between;
    padding: 12px 16px 12px 14px;
    .sport-ico {
      width: ${sportIconSize};
      height: ${sportIconSize};
      margin: 0 6px 1px 0 !important;
    }
    .table {
      display: block;
      width: calc((100% - 14px) / 2);
      &--head {
        display: block;
        font-size: ${props => props.theme.font.medium};
        height: 16px;
        margin-bottom: 8px;
        & tr {
          display: flex;
          justify-content: space-between;
          .screen-out {
            width: calc(100% - 30px);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .round {
            font-weight: ${props => props.theme.fontW.medium};
            text-align: right
          }
        }
      }
      & th {
        font-weight: ${props => props.theme.fontW.medium};
        height: 18px;
        color: ${props => props.theme.color.gray};
      }
      &--body {
        display: block;
        font-size: ${props => props.theme.font.medium};
        & tr {
          display: flex;
          justify-content: space-between;
          height: 17px;
          margin-bottom: 10px;
        }
        .sport-ico {
          margin-right: 2px;
        }
        .team-name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 120px;
          font-weight: ${props => props.theme.fontW.medium};
          text-align: left;
          color: ${props => props.theme.color.modalSubTxt};
        }
        .score {
          text-align: right;
        }
      }
    }
    &::before {
      content: '';
      display: block;
      width: 1px;
      height: 192px;
      background-color: ${props => props.theme.color.modalSubBg};
      position: absolute;
      bottom: 66px;
      left: 50%;
      transform: translateX(-50%);
    }
    &.icehockey {
      .table {
        background: red;
      }
    }
  }

  // 축구 타임라인팝업카드 -> 탭
  .am-tabs-tab-bar-wrap {
    width: 100%;
    height: 38px;
    background: ${props => props.theme.color.modalSubBg2};
    padding: 0 16px;
    .am-tabs-default-bar-content {
      width: 105px;
      .am-tabs-default-bar-tab {
        height: 100%;
        line-height: 38px;
        padding: 12px 0 8px 0;
        .soccer-tab-item {
          width: 30px;
          height: 100%;
          display: flex;
          align-items: center;
          position: relative;
          cursor: pointer;
          .sport-ico {
            width: auto;
            height: 21px;
            position: absolute;
            left: 0;
            opacity: 1;
            &-active {
              width: auto;
              height: 21px;
              opacity: 0;
            }
          }
          .num {
            width: 14px;
            height: 14px;
            border-radius: 50%;
            position: absolute;
            right: 2px;
            top: -2px;
            background: ${props => props.theme.color.modalgray};
            color: ${props => props.theme.color.themeTxt};
            font-size: ${props => props.theme.font.small};
            line-height: ${props => props.theme.font.large};
            text-align: center;
            padding: .5px 1px 1px;
          }
        }
        &-active {
          .soccer-tab-item {
            .sport-ico {
              opacity: 0;
              &-active {
                opacity: 1;
              }
            }
            .num {
              background: ${props => props.theme.color.subColor2};
            }
          }
        }
      }
    }
    .am-tabs-default-bar-underline {
      display: none;
    }

  }
`
export const VisualizationWarap = styled.div`
  .sr-error__container {
    background: url('../images/error_bg.png') no-repeat center center;
  }

  .sr-lmt-plus__footer-wrapper {
    display: none;
  }

  .sr-lmt-plus-scb__status.srt-text-secondary.srt-neutral-9.srm-right {
    margin-top: 2px;
  }

  .sr-error__icon-wrapper.srm-is-medium, .sr-error__message-wrapper.srm-is-medium {
    display: none;
  }

  .sr-bb {
    font-family: "Roboto", "Noto", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
    background: #203040;
  }

  .sr-bb .sr-bb {
    background: none;
  }

  .sr-bb .srt-base-1 {
    background-color: transparent;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-base-1-win {
    background-color: transparent;
    color: #fd2954;
    border-color: #fd2954;
  }

  .sr-bb .srt-base-1-draw {
    background-color: transparent;
    color: #4c4c65;
    border-color: #4c4c65;
  }

  .sr-bb .srt-base-1-lose {
    background-color: transparent;
    color: #821e44;
    border-color: #821e44;
  }

  .sr-bb .srt-base-1-is-active {
    background-color: rgba(253, 41, 84, 0.12);
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-base-1-is-active-2 {
    background-color: #2c2c49;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-base-1-is-hoverable:hover {
    background-color: rgba(253, 41, 84, 0.12);
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-base-1-primary {
    background-color: transparent;
    color: #1ABC9C;
    border-color: #1ABC9C;
  }

  .sr-bb .srt-base-1-home-1 {
    background-color: transparent;
    color: #42BBDA;
    border-color: #42BBDA;
  }

  .sr-bb .srt-base-1-away-1 {
    background-color: transparent;
    color: #E47B36;
    border-color: #E47B36;
  }

  .sr-bb .srt-base-1-home-2 {
    background-color: transparent;
    color: #42BBDA;
    border-color: #fe839c;
  }

  .sr-bb .srt-base-1-away-2 {
    background-color: transparent;
    color: #E47B36;
    border-color: #fe839c;
  }

  .sr-bb .srt-base-1-home-3 {
    background-color: transparent;
    color: #42BBDA;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-base-1-away-3 {
    background-color: transparent;
    color: #E47B36;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-base-1-home-4 {
    background-color: transparent;
    color: #096eaf;
    border-color: #096eaf;
  }

  .sr-bb .srt-base-1-away-4 {
    background-color: transparent;
    color: #b7234b;
    border-color: #b7234b;
  }

  .sr-bb .srt-base-1-home-5 {
    background-color: transparent;
    color: #5cbaed;
    border-color: #5cbaed;
  }

  .sr-bb .srt-base-1-away-5 {
    background-color: transparent;
    color: #fe7490;
    border-color: #fe7490;
  }

  .sr-bb .srt-base-1-background {
    background-color: #203040;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-base-2 {
    background-color: #203040;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-base-2-is-active {
    background-color: #301739;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-base-2-is-hoverable:hover {
    background-color: #301739;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-base-3 {
    background-color: #301739;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-base-3-is-active {
    background-color: #3c183a;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-base-3-is-hoverable:hover {
    background-color: #3c183a;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-base-3-background {
    background-color: #203040;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-base-4 {
    background-color: #201537;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-base-5-is-active {
    background-color: #51193d;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-base-5-is-hoverable:hover {
    background-color: #51193d;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-base-6 {
    background-color: transparent;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.3);
  }

  .sr-bb .srt-primary-1 {
    background-color: #1ABC9C;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-1-is-active {
    background-color: #fd3e65;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-1-is-hoverable:hover {
    background-color: #fd3e65;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-1-is-disabled {
    background-color: #fd5476;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-2 {
    background-color: #fe6987;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-3 {
    background-color: #fd3e65;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-4 {
    background-color: #a02148;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-5 {
    background-color: #a02148;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-5-is-hoverable:hover {
    background-color: #1ABC9C;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-6 {
    background-color: #fe839c;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-7 {
    background-color: #1ABC9C;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-8 {
    background-color: #1ABC9C;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-8-is-active-1 {
    background-color: #fd3e65;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-8-is-active-2 {
    background-color: #fd3e65;
    color: #DDDDDD;
    border-color: #203040;
  }

  .sr-bb .srt-primary-9 {
    background-color: #5a1a3e;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-primary-10 {
    background-color: #ce254e;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-11 {
    background-color: #fd3e65;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-12 {
    background-color: #1ABC9C;
    color: #DDDDDD;
    border-color: #DDDDDD;
  }

  .sr-bb .srt-primary-13 {
    background-color: #201537;
    color: #DDDDDD;
    border-color: rgba(253, 41, 84, 0.3);
  }

  .sr-bb .srt-base-1-primary-1 {
    background-color: transparent;
    color: #1ABC9C;
    border-color: #1ABC9C;
  }

  .sr-bb .srt-base-1-primary-2 {
    background-color: transparent;
    color: #fe6987;
    border-color: #fe6987;
  }

  .sr-bb .srt-base-1-primary-3 {
    background-color: transparent;
    color: #fd3e65;
    border-color: #fd3e65;
  }

  .sr-bb .srt-base-1-primary-4 {
    background-color: transparent;
    color: #a02148;
    border-color: #a02148;
  }

  .sr-bb .srt-base-1-primary-5 {
    background-color: transparent;
    color: #a02148;
    border-color: #a02148;
  }

  .sr-bb .srt-base-1-primary-6 {
    background-color: transparent;
    color: #fe839c;
    border-color: #fe839c;
  }

  .sr-bb .srt-base-1-primary-7 {
    background-color: transparent;
    color: #1ABC9C;
    border-color: #1ABC9C;
  }

  .sr-bb .srt-base-1-primary-8 {
    background-color: transparent;
    color: #1ABC9C;
    border-color: #1ABC9C;
  }

  .sr-bb .srt-base-1-primary-9 {
    background-color: transparent;
    color: #5a1a3e;
    border-color: #5a1a3e;
  }

  .sr-bb .srt-base-1-primary-10 {
    background-color: transparent;
    color: #ce254e;
    border-color: #ce254e;
  }

  .sr-bb .srt-base-1-primary-11 {
    background-color: transparent;
    color: #fd3e65;
    border-color: #fd3e65;
  }

  .sr-bb .srt-base-1-primary-13 {
    background-color: #203040;
    color: #201537;
    border-color: rgba(253, 41, 84, 0.3);
  }

  .sr-bb .srt-base-1-neutral-1 {
    background-color: transparent;
    color: #33334f;
    border-color: #33334f;
  }

  .sr-bb .srt-base-1-neutral-2 {
    background-color: transparent;
    color: #e8e8eb;
    border-color: #e8e8eb;
  }

  .sr-bb .srt-base-1-neutral-3 {
    background-color: transparent;
    color: rgba(255, 255, 255, 0.12);
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-base-1-neutral-4 {
    background-color: transparent;
    color: #adadb8;
    border-color: #adadb8;
  }

  .sr-bb .srt-base-1-neutral-5 {
    background-color: transparent;
    color: #c4c4cd;
    border-color: #c4c4cd;
  }

  .sr-bb .srt-base-1-neutral-6 {
    background-color: transparent;
    color: #4c4c65;
    border-color: #4c4c65;
  }

  .sr-bb .srt-base-1-neutral-7 {
    background-color: transparent;
    color: #adadb8;
    border-color: #adadb8;
  }

  .sr-bb .srt-base-1-neutral-8 {
    background-color: transparent;
    color: #33334f;
    border-color: #33334f;
  }

  .sr-bb .srt-base-1-neutral-9 {
    background-color: transparent;
    color: #222241;
    border-color: #222241;
  }

  .sr-bb .srt-base-1-neutral-10 {
    background-color: transparent;
    color: #30304d;
    border-color: #30304d;
  }

  .sr-bb .srt-base-1-neutral-11 {
    background-color: transparent;
    color: #727286;
    border-color: #727286;
  }

  .sr-bb .srt-base-1-neutral-12 {
    background-color: transparent;
    color: #b9b9c2;
    border-color: #b9b9c2;
  }

  .sr-bb .srt-base-1-neutral-13 {
    background-color: transparent;
    color: #2c2c49;
    border-color: #2c2c49;
  }

  .sr-bb .srt-base-1-is-active-primary {
    background-color: rgba(253, 41, 84, 0.12);
    color: #1ABC9C;
    border-color: #1ABC9C;
  }

  .sr-bb .srt-base-1-is-active-home-1 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #42BBDA;
    border-color: #42BBDA;
  }

  .sr-bb .srt-base-1-is-active-away-1 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #E47B36;
    border-color: #E47B36;
  }

  .sr-bb .srt-base-1-is-active-home-2 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #42BBDA;
    border-color: #fe839c;
  }

  .sr-bb .srt-base-1-is-active-away-2 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #E47B36;
    border-color: #fe839c;
  }

  .sr-bb .srt-base-1-is-active-home-3 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #42BBDA;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-base-1-is-active-away-3 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #E47B36;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-base-1-is-active-home-4 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #096eaf;
    border-color: #096eaf;
  }

  .sr-bb .srt-base-1-is-active-away-4 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #b7234b;
    border-color: #b7234b;
  }

  .sr-bb .srt-base-1-is-active-home-5 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #5cbaed;
    border-color: #5cbaed;
  }

  .sr-bb .srt-base-1-is-active-away-5 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #fe7490;
    border-color: #fe7490;
  }

  .sr-bb .srt-base-1-is-active-primary-1 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #1ABC9C;
    border-color: #1ABC9C;
  }

  .sr-bb .srt-base-1-is-active-primary-2 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #fe6987;
    border-color: #fe6987;
  }

  .sr-bb .srt-base-1-is-active-primary-3 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #fd3e65;
    border-color: #fd3e65;
  }

  .sr-bb .srt-base-1-is-active-primary-4 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #a02148;
    border-color: #a02148;
  }

  .sr-bb .srt-base-1-is-active-primary-5 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #a02148;
    border-color: #a02148;
  }

  .sr-bb .srt-base-1-is-active-primary-6 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #fe839c;
    border-color: #fe839c;
  }

  .sr-bb .srt-base-1-is-active-primary-7 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #1ABC9C;
    border-color: #1ABC9C;
  }

  .sr-bb .srt-base-1-is-active-primary-8 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #1ABC9C;
    border-color: #1ABC9C;
  }

  .sr-bb .srt-base-1-is-active-primary-9 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #5a1a3e;
    border-color: #5a1a3e;
  }

  .sr-bb .srt-base-1-is-active-primary-10 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #ce254e;
    border-color: #ce254e;
  }

  .sr-bb .srt-base-1-is-active-primary-11 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #fd3e65;
    border-color: #fd3e65;
  }

  .sr-bb .srt-base-1-is-active-neutral-1 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #33334f;
    border-color: #33334f;
  }

  .sr-bb .srt-base-1-is-active-neutral-2 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #e8e8eb;
    border-color: #e8e8eb;
  }

  .sr-bb .srt-base-1-is-active-neutral-3 {
    background-color: rgba(253, 41, 84, 0.12);
    color: rgba(255, 255, 255, 0.12);
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-base-1-is-active-neutral-4 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #adadb8;
    border-color: #adadb8;
  }

  .sr-bb .srt-base-1-is-active-neutral-5 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #c4c4cd;
    border-color: #c4c4cd;
  }

  .sr-bb .srt-base-1-is-active-neutral-6 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #4c4c65;
    border-color: #4c4c65;
  }

  .sr-bb .srt-base-1-is-active-neutral-7 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #adadb8;
    border-color: #adadb8;
  }

  .sr-bb .srt-base-1-is-active-neutral-8 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #33334f;
    border-color: #33334f;
  }

  .sr-bb .srt-base-1-is-active-neutral-9 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #222241;
    border-color: #222241;
  }

  .sr-bb .srt-base-1-is-active-neutral-10 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #30304d;
    border-color: #30304d;
  }

  .sr-bb .srt-base-1-is-active-neutral-11 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #727286;
    border-color: #727286;
  }

  .sr-bb .srt-base-1-is-active-neutral-12 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #b9b9c2;
    border-color: #b9b9c2;
  }

  .sr-bb .srt-base-1-is-active-neutral-13 {
    background-color: rgba(253, 41, 84, 0.12);
    color: #2c2c49;
    border-color: #2c2c49;
  }

  .sr-bb .srt-home-1 {
    background-color: #42BBDA;
    color: #DDDDDD;
    border-color: #42BBDA;
  }

  .sr-bb .srt-away-1 {
    background-color: #E47B36;
    color: #DDDDDD;
    border-color: #E47B36;
  }

  .sr-bb .srt-home-2 {
    background-color: #42BBDA;
    color: #DDDDDD;
    border-color: #fe839c;
  }

  .sr-bb .srt-away-2 {
    background-color: #E47B36;
    color: #DDDDDD;
    border-color: #fe839c;
  }

  .sr-bb .srt-home-3 {
    background-color: #42BBDA;
    color: #DDDDDD;
    border-color: #203040;
  }

  .sr-bb .srt-away-3 {
    background-color: #E47B36;
    color: #DDDDDD;
    border-color: #203040;
  }

  .sr-bb .srt-home-4 {
    background-color: #096eaf;
    color: #DDDDDD;
    border-color: #096eaf;
  }

  .sr-bb .srt-away-4 {
    background-color: #b7234b;
    color: #DDDDDD;
    border-color: #b7234b;
  }

  .sr-bb .srt-home-5 {
    background-color: #5cbaed;
    color: #DDDDDD;
    border-color: #5cbaed;
  }

  .sr-bb .srt-away-5 {
    background-color: #fe7490;
    color: #DDDDDD;
    border-color: #fe7490;
  }

  .sr-bb .srt-neutral-1 {
    background-color: #33334f;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-neutral-2 {
    background-color: #e8e8eb;
    color: #000000;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-neutral-3 {
    background-color: rgba(255, 255, 255, 0.12);
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-neutral-4 {
    background-color: #adadb8;
    color: #000000;
    border-color: rgba(0, 0, 0, 0.16);
  }

  .sr-bb .srt-neutral-5 {
    background-color: #c4c4cd;
    color: #000000;
    border-color: rgba(0, 0, 0, 0.16);
  }

  .sr-bb .srt-neutral-6 {
    background-color: #4c4c65;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-neutral-7 {
    background-color: #adadb8;
    color: #000000;
    border-color: rgba(0, 0, 0, 0.16);
  }

  .sr-bb .srt-neutral-8 {
    background-color: #33334f;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-neutral-9 {
    background-color: #222241;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-neutral-10 {
    background-color: #30304d;
    color: rgba(255, 255, 255, 0.82);
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-neutral-11 {
    background-color: #727286;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-neutral-12 {
    background-color: #b9b9c2;
    color: #000000;
    border-color: rgba(0, 0, 0, 0.16);
  }

  .sr-bb .srt-neutral-13 {
    background-color: #2c2c49;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-win {
    background-color: #fd2954;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-draw {
    background-color: #4c4c65;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-lose {
    background-color: #821e44;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-text-secondary {
    opacity: 0.8;
  }

  .sr-bb .srt-text-disabled {
    opacity: 0.6;
  }

  .sr-bb .srt-text-tertiary {
    opacity: 0.7;
  }

  .sr-bb .srt-primary-1 .srt-text-secondary, .sr-bb .srt-primary-1.srt-text-secondary,
  .sr-bb .srt-primary-1-is-active .srt-text-secondary,
  .sr-bb .srt-primary-1-is-active.srt-text-secondary,
  .sr-bb .srt-primary-1-is-hoverable:hover .srt-text-secondary,
  .sr-bb .srt-primary-1-is-hoverable:hover.srt-text-secondary,
  .sr-bb .srt-primary-1-is-disabled .srt-text-secondary,
  .sr-bb .srt-primary-1-is-disabled.srt-text-secondary,
  .sr-bb .srt-primary-2 .srt-text-secondary,
  .sr-bb .srt-primary-2.srt-text-secondary,
  .sr-bb .srt-primary-3 .srt-text-secondary,
  .sr-bb .srt-primary-3.srt-text-secondary,
  .sr-bb .srt-primary-4 .srt-text-secondary,
  .sr-bb .srt-primary-4.srt-text-secondary,
  .sr-bb .srt-primary-5 .srt-text-secondary,
  .sr-bb .srt-primary-5.srt-text-secondary,
  .sr-bb .srt-primary-5-is-hoverable:hover .srt-text-secondary,
  .sr-bb .srt-primary-5-is-hoverable:hover.srt-text-secondary,
  .sr-bb .srt-primary-6 .srt-text-secondary,
  .sr-bb .srt-primary-6.srt-text-secondary,
  .sr-bb .srt-primary-7 .srt-text-secondary,
  .sr-bb .srt-primary-7.srt-text-secondary,
  .sr-bb .srt-primary-8 .srt-text-secondary,
  .sr-bb .srt-primary-8.srt-text-secondary,
  .sr-bb .srt-primary-8-is-active-1 .srt-text-secondary,
  .sr-bb .srt-primary-8-is-active-1.srt-text-secondary,
  .sr-bb .srt-primary-8-is-active-2 .srt-text-secondary,
  .sr-bb .srt-primary-8-is-active-2.srt-text-secondary,
  .sr-bb .srt-primary-9 .srt-text-secondary,
  .sr-bb .srt-primary-9.srt-text-secondary,
  .sr-bb .srt-primary-10 .srt-text-secondary,
  .sr-bb .srt-primary-10.srt-text-secondary,
  .sr-bb .srt-primary-11 .srt-text-secondary,
  .sr-bb .srt-primary-11.srt-text-secondary,
  .sr-bb .srt-primary-12 .srt-text-secondary,
  .sr-bb .srt-primary-12.srt-text-secondary,
  .sr-bb .srt-primary-13 .srt-text-secondary,
  .sr-bb .srt-primary-13.srt-text-secondary {
    opacity: 0.8;
  }

  .sr-bb .srt-primary-1 .srt-text-disabled, .sr-bb .srt-primary-1.srt-text-disabled,
  .sr-bb .srt-primary-1-is-active .srt-text-disabled,
  .sr-bb .srt-primary-1-is-active.srt-text-disabled,
  .sr-bb .srt-primary-1-is-hoverable:hover .srt-text-disabled,
  .sr-bb .srt-primary-1-is-hoverable:hover.srt-text-disabled,
  .sr-bb .srt-primary-1-is-disabled .srt-text-disabled,
  .sr-bb .srt-primary-1-is-disabled.srt-text-disabled,
  .sr-bb .srt-primary-2 .srt-text-disabled,
  .sr-bb .srt-primary-2.srt-text-disabled,
  .sr-bb .srt-primary-3 .srt-text-disabled,
  .sr-bb .srt-primary-3.srt-text-disabled,
  .sr-bb .srt-primary-4 .srt-text-disabled,
  .sr-bb .srt-primary-4.srt-text-disabled,
  .sr-bb .srt-primary-5 .srt-text-disabled,
  .sr-bb .srt-primary-5.srt-text-disabled,
  .sr-bb .srt-primary-5-is-hoverable:hover .srt-text-disabled,
  .sr-bb .srt-primary-5-is-hoverable:hover.srt-text-disabled,
  .sr-bb .srt-primary-6 .srt-text-disabled,
  .sr-bb .srt-primary-6.srt-text-disabled,
  .sr-bb .srt-primary-7 .srt-text-disabled,
  .sr-bb .srt-primary-7.srt-text-disabled,
  .sr-bb .srt-primary-8 .srt-text-disabled,
  .sr-bb .srt-primary-8.srt-text-disabled,
  .sr-bb .srt-primary-8-is-active-1 .srt-text-disabled,
  .sr-bb .srt-primary-8-is-active-1.srt-text-disabled,
  .sr-bb .srt-primary-8-is-active-2 .srt-text-disabled,
  .sr-bb .srt-primary-8-is-active-2.srt-text-disabled,
  .sr-bb .srt-primary-9 .srt-text-disabled,
  .sr-bb .srt-primary-9.srt-text-disabled,
  .sr-bb .srt-primary-10 .srt-text-disabled,
  .sr-bb .srt-primary-10.srt-text-disabled,
  .sr-bb .srt-primary-11 .srt-text-disabled,
  .sr-bb .srt-primary-11.srt-text-disabled,
  .sr-bb .srt-primary-12 .srt-text-disabled,
  .sr-bb .srt-primary-12.srt-text-disabled,
  .sr-bb .srt-primary-13 .srt-text-disabled,
  .sr-bb .srt-primary-13.srt-text-disabled {
    opacity: 0.6;
  }

  .sr-bb .srt-primary-1 .srt-text-tertiary, .sr-bb .srt-primary-1.srt-text-tertiary,
  .sr-bb .srt-primary-1-is-active .srt-text-tertiary,
  .sr-bb .srt-primary-1-is-active.srt-text-tertiary,
  .sr-bb .srt-primary-1-is-hoverable:hover .srt-text-tertiary,
  .sr-bb .srt-primary-1-is-hoverable:hover.srt-text-tertiary,
  .sr-bb .srt-primary-1-is-disabled .srt-text-tertiary,
  .sr-bb .srt-primary-1-is-disabled.srt-text-tertiary,
  .sr-bb .srt-primary-2 .srt-text-tertiary,
  .sr-bb .srt-primary-2.srt-text-tertiary,
  .sr-bb .srt-primary-3 .srt-text-tertiary,
  .sr-bb .srt-primary-3.srt-text-tertiary,
  .sr-bb .srt-primary-4 .srt-text-tertiary,
  .sr-bb .srt-primary-4.srt-text-tertiary,
  .sr-bb .srt-primary-5 .srt-text-tertiary,
  .sr-bb .srt-primary-5.srt-text-tertiary,
  .sr-bb .srt-primary-5-is-hoverable:hover .srt-text-tertiary,
  .sr-bb .srt-primary-5-is-hoverable:hover.srt-text-tertiary,
  .sr-bb .srt-primary-6 .srt-text-tertiary,
  .sr-bb .srt-primary-6.srt-text-tertiary,
  .sr-bb .srt-primary-7 .srt-text-tertiary,
  .sr-bb .srt-primary-7.srt-text-tertiary,
  .sr-bb .srt-primary-8 .srt-text-tertiary,
  .sr-bb .srt-primary-8.srt-text-tertiary,
  .sr-bb .srt-primary-8-is-active-1 .srt-text-tertiary,
  .sr-bb .srt-primary-8-is-active-1.srt-text-tertiary,
  .sr-bb .srt-primary-8-is-active-2 .srt-text-tertiary,
  .sr-bb .srt-primary-8-is-active-2.srt-text-tertiary,
  .sr-bb .srt-primary-9 .srt-text-tertiary,
  .sr-bb .srt-primary-9.srt-text-tertiary,
  .sr-bb .srt-primary-10 .srt-text-tertiary,
  .sr-bb .srt-primary-10.srt-text-tertiary,
  .sr-bb .srt-primary-11 .srt-text-tertiary,
  .sr-bb .srt-primary-11.srt-text-tertiary,
  .sr-bb .srt-primary-12 .srt-text-tertiary,
  .sr-bb .srt-primary-12.srt-text-tertiary,
  .sr-bb .srt-primary-13 .srt-text-tertiary,
  .sr-bb .srt-primary-13.srt-text-tertiary {
    opacity: 0.7;
  }

  .sr-bb .srt-icon {
    opacity: 0.33;
  }

  .sr-bb .srt-icon-secondary {
    opacity: 0.7;
  }

  .sr-bb .srt-elevation-1 {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  }

  .sr-bb .srt-elevation-2 {
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.23), 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  }

  .sr-bb .srt-elevation-3 {
    box-shadow: 0 6px 6px 0 rgba(0, 0, 0, 0.26), 0 10px 20px 0 rgba(0, 0, 0, 0.19);
  }

  .sr-bb .srt-elevation-center-2 {
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.23), 0 1px 5px rgba(0, 0, 0, 0.16);
  }

  .sr-bb .srt-inset-top-1 {
    box-shadow: inset 0 1px 2px 0 rgba(0, 0, 0, 0.23);
  }

  .sr-bb .srt-inset-bottom-1 {
    box-shadow: inset 0 -1px 2px 0 rgba(0, 0, 0, 0.23);
  }

  .sr-bb .srt-inset-top-2 {
    box-shadow: inset 0 3px 6px 0 rgba(0, 0, 0, 0.23);
  }

  .sr-bb .srt-inset-bottom-2 {
    box-shadow: inset 0 -3px 6px 0 rgba(0, 0, 0, 0.23);
  }

  .sr-bb .srt-inset-top-3 {
    box-shadow: inset 0 6px 6px 0 rgba(0, 0, 0, 0.23);
  }

  .sr-bb .srt-inset-bottom-3 {
    box-shadow: inset 0 -6px 6px 0 rgba(0, 0, 0, 0.23);
  }

  .sr-bb .srt-fill-blue-card {
    fill: #2579ad;
  }

  .sr-bb .srt-stroke-blue-card {
    stroke: #2579ad;
  }

  .sr-bb .srt-fill-soccer-yellow-card {
    fill: #ffbf00;
  }

  .sr-bb .srt-stroke-soccer-yellow-card {
    stroke: #ffbf00;
  }

  .sr-bb .srt-fill-soccer-red-card {
    fill: #e43b3b;
  }

  .sr-bb .srt-stroke-soccer-red-card {
    stroke: #e43b3b;
  }

  .sr-bb .srt-stroke-soccer-substitution-in {
    stroke: #4fbe30;
    fill: transparent;
  }

  .sr-bb .srt-fill-soccer-substitution-in {
    fill: #4fbe30;
  }

  .sr-bb .srt-stroke-soccer-substitution-out {
    stroke: #e43b3b;
    fill: transparent;
  }

  .sr-bb .srt-fill-soccer-substitution-out {
    fill: #e43b3b;
  }

  .sr-bb .srt-stroke-soccer-own-goal {
    stroke: #e43b3b;
    fill: transparent;
  }

  .sr-bb .srt-fill-soccer-own-goal {
    fill: #e43b3b;
  }

  .sr-bb .srt-fill-soccer-relegation-1 {
    fill: #fdd835;
  }

  .sr-bb .srt-stroke-soccer-relegation-1 {
    stroke: #fdd835;
  }

  .sr-bb .srt-fill-soccer-relegation-2 {
    fill: #ffb848;
  }

  .sr-bb .srt-stroke-soccer-relegation-2 {
    stroke: #ffb848;
  }

  .sr-bb .srt-fill-soccer-relegation-3 {
    fill: #ef6c00;
  }

  .sr-bb .srt-stroke-soccer-relegation-3 {
    stroke: #ef6c00;
  }

  .sr-bb .srt-fill-soccer-relegation-4 {
    fill: #e93a34;
  }

  .sr-bb .srt-stroke-soccer-relegation-4 {
    stroke: #e93a34;
  }

  .sr-bb .srt-fill-soccer-relegation-5 {
    fill: #941d1d;
  }

  .sr-bb .srt-stroke-soccer-relegation-5 {
    stroke: #941d1d;
  }

  .sr-bb .srt-fill-soccer-promotion-1 {
    fill: #51d151;
  }

  .sr-bb .srt-stroke-soccer-promotion-1 {
    stroke: #51d151;
  }

  .sr-bb .srt-fill-soccer-promotion-2 {
    fill: #1b911b;
  }

  .sr-bb .srt-stroke-soccer-promotion-2 {
    stroke: #1b911b;
  }

  .sr-bb .srt-fill-soccer-promotion-3 {
    fill: #0e8094;
  }

  .sr-bb .srt-stroke-soccer-promotion-3 {
    stroke: #0e8094;
  }

  .sr-bb .srt-fill-soccer-promotion-4 {
    fill: #0a6cce;
  }

  .sr-bb .srt-stroke-soccer-promotion-4 {
    stroke: #0a6cce;
  }

  .sr-bb .srt-fill-soccer-promotion-5 {
    fill: #4a9fe4;
  }

  .sr-bb .srt-stroke-soccer-promotion-5 {
    stroke: #4a9fe4;
  }

  .sr-bb .srt-nfl-timeout-1 {
    background-color: #f5a623;
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-nfl-timeout-2 {
    background-color: rgba(245, 166, 35, 0.3);
    color: #DDDDDD;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-nfl-penalty {
    background-color: #f4a621;
    color: #DDDDDD;
    border-color: #f4a621;
  }

  .sr-bb .srt-nfl-negative-yards-1 {
    background-color: #ac182e;
    color: #DDDDDD;
    border-color: #ac182e;
  }

  .sr-bb .srt-nfl-negative-yards-2 {
    background-color: #ac182e;
    color: #DDDDDD;
    border-color: #ac182e;
  }

  .sr-bb .srt-nfl-first-line {
    background-color: #4b90de;
    color: #DDDDDD;
    border-color: #4b90de;
  }

  .sr-bb .srt-nfl-ten-line {
    background-color: #f5a623;
    color: #DDDDDD;
    border-color: #f5a623;
  }

  .sr-bb .srt-fill-nfl-penalty {
    fill: #f4a621;
  }

  .sr-bb .srt-stroke-nfl-penalty {
    stroke: #f4a621;
  }

  .sr-bb .srt-fill-nfl-negative-yards-1 {
    fill: #ac182e;
  }

  .sr-bb .srt-stroke-nfl-negative-yards-1 {
    stroke: #ac182e;
  }

  .sr-bb .srt-fill-nfl-negative-yards-2 {
    fill: #ac182e;
  }

  .sr-bb .srt-stroke-nfl-negative-yards-2 {
    stroke: #ac182e;
  }

  .sr-bb .srt-fill-nfl-first-line {
    fill: #4b90de;
  }

  .sr-bb .srt-stroke-nfl-first-line {
    stroke: #4b90de;
  }

  .sr-bb .srt-fill-nfl-ten-line {
    fill: #f5a623;
  }

  .sr-bb .srt-stroke-nfl-ten-line {
    stroke: #f5a623;
  }

  .sr-bb .srt-mlb-run-1 {
    background-color: #009900;
    color: #DDDDDD;
    border-color: #009900;
  }

  .sr-bb .srt-mlb-run-2 {
    background-color: #DDDDDD;
    color: #009900;
    border-color: #009900;
  }

  .sr-bb .srt-mlb-hit-1 {
    background-color: #f7ab11;
    color: #DDDDDD;
    border-color: #f7ab11;
  }

  .sr-bb .srt-mlb-hit-2 {
    background-color: #DDDDDD;
    color: #f7ab11;
    border-color: #f7ab11;
  }

  .sr-bb .srt-mlb-hit-3 {
    background-color: #00a4ff;
    color: #DDDDDD;
    border-color: #00a4ff;
  }

  .sr-bb .srt-mlb-error-1 {
    background-color: #d0021b;
    color: #DDDDDD;
    border-color: #d0021b;
  }

  .sr-bb .srt-mlb-error-2 {
    background-color: #DDDDDD;
    color: #d0021b;
    border-color: #d0021b;
  }

  .sr-bb .srt-mlb-neutral-1 {
    background-color: #212121;
    color: #DDDDDD;
    border-color: #DDDDDD;
  }

  .sr-bb .srt-fill-mlb-base {
    fill: #00a4ff;
  }

  .sr-bb .srt-strole-mlb-base {
    fill: #00a4ff;
  }

  .sr-bb .srt-fill-change-increase {
    fill: #fd2954;
  }

  .sr-bb .srt-stroke-change-increase {
    stroke: #fd2954;
  }

  .sr-bb .srt-fill-change-decrease {
    fill: #821e44;
  }

  .sr-bb .srt-stroke-change-decrease {
    stroke: #821e44;
  }

  .sr-bb .srt-fill-text {
    fill: #DDDDDD;
  }

  .sr-bb .srt-fill-text-invert {
    fill: #DDDDDD;
  }

  .sr-bb .srt-fill-text-secondary {
    fill-opacity: 0.8;
  }

  .sr-bb .srt-fill-text-disabled {
    fill-opacity: 0.6;
  }

  .sr-bb .srt-fill-base-1 {
    fill: transparent;
  }

  .sr-bb .srt-stroke-base-1 {
    stroke: transparent;
  }

  .sr-bb .srt-fill-base-1-active {
    fill: rgba(253, 41, 84, 0.12);
  }

  .sr-bb .srt-stroke-base-1-active {
    stroke: rgba(253, 41, 84, 0.12);
  }

  .sr-bb .srt-fill-base-1-active-2 {
    fill: #2c2c49;
  }

  .sr-bb .srt-stroke-base-1-active-2 {
    stroke: #2c2c49;
  }

  .sr-bb .srt-fill-base-1-primary {
    fill: transparent;
  }

  .sr-bb .srt-stroke-base-1-primary {
    stroke: transparent;
  }

  .sr-bb .srt-fill-base-1-home {
    fill: transparent;
  }

  .sr-bb .srt-stroke-base-1-home {
    stroke: transparent;
  }

  .sr-bb .srt-fill-base-1-away {
    fill: transparent;
  }

  .sr-bb .srt-stroke-base-1-away {
    stroke: transparent;
  }

  .sr-bb .srt-fill-base-2 {
    fill: currentColor;
  }

  .sr-bb .srt-stroke-base-2 {
    stroke: currentColor;
  }

  .sr-bb .srt-fill-base-2-active {
    fill: #301739;
  }

  .sr-bb .srt-stroke-base-2-active {
    stroke: #301739;
  }

  .sr-bb .srt-fill-base-2-hover {
    fill: #301739;
  }

  .sr-bb .srt-stroke-base-2-hover {
    stroke: #301739;
  }

  .sr-bb .srt-fill-base-3 {
    fill: #301739;
  }

  .sr-bb .srt-stroke-base-3 {
    stroke: #301739;
  }

  .sr-bb .srt-fill-base-3-active {
    fill: #3c183a;
  }

  .sr-bb .srt-stroke-base-3-active {
    stroke: #3c183a;
  }

  .sr-bb .srt-fill-base-3-hover {
    fill: #3c183a;
  }

  .sr-bb .srt-stroke-base-3-hover {
    stroke: #3c183a;
  }

  .sr-bb .srt-fill-primary-1 {
    fill: #1ABC9C;
  }

  .sr-bb .srt-stroke-primary-1 {
    stroke: #1ABC9C;
  }

  .sr-bb .srt-fill-primary-2 {
    fill: #fe6987;
  }

  .sr-bb .srt-stroke-primary-2 {
    stroke: #fe6987;
  }

  .sr-bb .srt-fill-primary-3 {
    fill: #fd3e65;
  }

  .sr-bb .srt-stroke-primary-3 {
    stroke: #fd3e65;
  }

  .sr-bb .srt-fill-primary-4 {
    fill: #a02148;
  }

  .sr-bb .srt-stroke-primary-4 {
    stroke: #a02148;
  }

  .sr-bb .srt-fill-primary-5 {
    fill: #a02148;
  }

  .sr-bb .srt-stroke-primary-5 {
    stroke: #a02148;
  }

  .sr-bb .srt-fill-primary-6 {
    fill: #fe839c;
  }

  .sr-bb .srt-stroke-primary-6 {
    stroke: #fe839c;
  }

  .sr-bb .srt-fill-primary-7 {
    fill: #1ABC9C;
  }

  .sr-bb .srt-stroke-primary-7 {
    stroke: #1ABC9C;
  }

  .sr-bb .srt-fill-primary-8 {
    fill: #1ABC9C;
  }

  .sr-bb .srt-stroke-primary-8 {
    stroke: #1ABC9C;
  }

  .sr-bb .srt-fill-primary-8-is-active-1 {
    fill: #fd3e65;
  }

  .sr-bb .srt-stroke-primary-8-is-active-1 {
    stroke: #fd3e65;
  }

  .sr-bb .srt-fill-primary-8-is-active-2 {
    fill: #fd3e65;
  }

  .sr-bb .srt-stroke-primary-8-is-active-2 {
    stroke: #fd3e65;
  }

  .sr-bb .srt-fill-primary-9 {
    fill: #5a1a3e;
  }

  .sr-bb .srt-stroke-primary-9 {
    stroke: #5a1a3e;
  }

  .sr-bb .srt-fill-primary-10 {
    fill: #ce254e;
  }

  .sr-bb .srt-stroke-primary-10 {
    stroke: #ce254e;
  }

  .sr-bb .srt-fill-primary-11 {
    fill: #fd3e65;
  }

  .sr-bb .srt-stroke-primary-11 {
    stroke: #fd3e65;
  }

  .sr-bb .srt-fill-primary-12 {
    fill: #1ABC9C;
  }

  .sr-bb .srt-stroke-primary-12 {
    stroke: #1ABC9C;
  }

  .sr-bb .srt-fill-home-1 {
    fill: #42BBDA;
  }

  .sr-bb .srt-stroke-home-1 {
    stroke: #42BBDA;
  }

  .sr-bb .srt-fill-home-2 {
    fill: #42BBDA;
  }

  .sr-bb .srt-stroke-home-2 {
    stroke: #42BBDA;
  }

  .sr-bb .srt-fill-home-3 {
    fill: #42BBDA;
  }

  .sr-bb .srt-stroke-home-3 {
    stroke: #42BBDA;
  }

  .sr-bb .srt-fill-home-4 {
    fill: #096eaf;
  }

  .sr-bb .srt-stroke-home-4 {
    stroke: #096eaf;
  }

  .sr-bb .srt-fill-home-5 {
    fill: #5cbaed;
  }

  .sr-bb .srt-stroke-home-5 {
    stroke: #5cbaed;
  }

  .sr-bb .srt-fill-away-1 {
    fill: #E47B36;
  }

  .sr-bb .srt-stroke-away-1 {
    stroke: #E47B36;
  }

  .sr-bb .srt-fill-away-2 {
    fill: #E47B36;
  }

  .sr-bb .srt-stroke-away-2 {
    stroke: #E47B36;
  }

  .sr-bb .srt-fill-away-3 {
    fill: #E47B36;
  }

  .sr-bb .srt-stroke-away-3 {
    stroke: #E47B36;
  }

  .sr-bb .srt-fill-away-4 {
    fill: #b7234b;
  }

  .sr-bb .srt-stroke-away-4 {
    stroke: #b7234b;
  }

  .sr-bb .srt-fill-away-5 {
    fill: #fe7490;
  }

  .sr-bb .srt-stroke-away-5 {
    stroke: #fe7490;
  }

  .sr-bb .srt-fill-neutral-1 {
    fill: #33334f;
  }

  .sr-bb .srt-stroke-neutral-1 {
    stroke: #33334f;
  }

  .sr-bb .srt-fill-neutral-2 {
    fill: #e8e8eb;
  }

  .sr-bb .srt-stroke-neutral-2 {
    stroke: #e8e8eb;
  }

  .sr-bb .srt-fill-neutral-3 {
    fill: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-stroke-neutral-3 {
    stroke: rgba(255, 255, 255, 0.12);
  }

  .sr-bb .srt-fill-neutral-4 {
    fill: #adadb8;
  }

  .sr-bb .srt-stroke-neutral-4 {
    stroke: #adadb8;
  }

  .sr-bb .srt-fill-neutral-5 {
    fill: #c4c4cd;
  }

  .sr-bb .srt-stroke-neutral-5 {
    stroke: #c4c4cd;
  }

  .sr-bb .srt-fill-neutral-6 {
    fill: #4c4c65;
  }

  .sr-bb .srt-stroke-neutral-6 {
    stroke: #4c4c65;
  }

  .sr-bb .srt-fill-neutral-7 {
    fill: #adadb8;
  }

  .sr-bb .srt-stroke-neutral-7 {
    stroke: #adadb8;
  }

  .sr-bb .srt-fill-neutral-8 {
    fill: #33334f;
  }

  .sr-bb .srt-stroke-neutral-8 {
    stroke: #33334f;
  }

  .sr-bb .srt-fill-neutral-9 {
    fill: #222241;
  }

  .sr-bb .srt-stroke-neutral-9 {
    stroke: #222241;
  }

  .sr-bb .srt-fill-neutral-10 {
    fill: #30304d;
  }

  .sr-bb .srt-stroke-neutral-10 {
    stroke: #30304d;
  }

  .sr-bb .srt-fill-neutral-11 {
    fill: #727286;
  }

  .sr-bb .srt-stroke-neutral-11 {
    stroke: #727286;
  }

  .sr-bb .srt-fill-neutral-12 {
    fill: #b9b9c2;
  }

  .sr-bb .srt-stroke-neutral-12 {
    stroke: #b9b9c2;
  }

  .sr-bb .srt-fill-neutral-13 {
    fill: #2c2c49;
  }

  .sr-bb .srt-stroke-neutral-13 {
    stroke: #2c2c49;
  }

  .sr-bb .srt-fill-win {
    fill: #fd2954;
  }

  .sr-bb .srt-stroke-win {
    stroke: #fd2954;
  }

  .sr-bb .srt-fill-draw {
    fill: #4c4c65;
  }

  .sr-bb .srt-stroke-draw {
    stroke: #4c4c65;
  }

  .sr-bb .srt-fill-lose {
    fill: #821e44;
  }

  .sr-bb .srt-stroke-lose {
    stroke: #821e44;
  }

  .sr-bb .srt-stop-base-1 {
    stop-color: transparent;
  }

  .sr-bb .srt-stop-primary-1 {
    stop-color: #1ABC9C;
  }

  .sr-bb .srt-stop-primary-2 {
    stop-color: #fe6987;
  }

  .sr-bb .srt-stop-primary-3 {
    stop-color: #fd3e65;
  }

  .sr-bb .srt-stop-primary-4 {
    stop-color: #a02148;
  }

  .sr-bb .srt-stop-primary-5 {
    stop-color: #a02148;
  }

  .sr-bb .srt-stop-primary-6 {
    stop-color: #fe839c;
  }

  .sr-bb .srt-stop-primary-7 {
    stop-color: #1ABC9C;
  }

  .sr-bb .srt-stop-primary-8 {
    stop-color: #1ABC9C;
  }

  .sr-bb .srt-stop-primary-9 {
    stop-color: #5a1a3e;
  }

  .sr-bb .srt-stop-primary-10 {
    stop-color: #ce254e;
  }

  .sr-bb .srt-stop-primary-11 {
    stop-color: #fd3e65;
  }

  .sr-bb .srt-stop-primary-12 {
    stop-color: #1ABC9C;
  }

  .sr-bb .srt-stop-home-1 {
    stop-color: #42BBDA;
  }

  .sr-bb .srt-stop-away-1 {
    stop-color: #E47B36;
  }

  .sr-bb .srt-fill-neutral-14 {
    fill: #203040;
  }

  .sr-bb .srt-stroke-neutral-14 {
    stroke: #203040;
  }

  .sr-bb .srt-logo-powered-by-light {
    display: none;
  }

  .sr-bb .srt-logo-powered-by-dark {
    display: inline-block;
  }

`
